/* ============================================================
   dbakers Designer Cake Builder JS
   Prefix: ddb-
   Metafield-driven wizard — adapts to each designer cake
   ============================================================ */

(function () {
  'use strict';

  /* ── Variant IDs ── */
  var VARIANT_IDS = {
    plaque: {
      'Black':   '31056595681327',
      'Pink':    '39356338929711',
      'Blue':    '39356338995247',
      'Purple':  '39387268087855',
      'Green':   '52971944542524'
    },
    topper: {
      'Silver':  '41032069316655',
      'Black':   '41032069447727',
      'Blue':    '41032069349423',
      'Pink':    '41032069382191',
      'Purple':  '41032069414959'
    },
    sparklers:      '31139639754799',
    rainbowCandles: '52437652013372',
    cakeServer:     '46434309144892',
    bow:            '46066014552380',
    coldPack:       '41195387748399',
    glutenFree:     '41210593968175'
  };

  /* ── State ── */
  var cfg = window.ddbProduct || {};
  var NO_GF_FLAVORS = ['Red Velvet & Chocolate', 'Red Velvet (Original)'];
  var NUT_FLAVORS   = [
    '▪️Carrot Cake with Dulce de Leche',
    '▪️Carrot Cake (Original)',
    '▪️ Nutella Vanilla',
    '✔️ Marble Cake: Nutella Fudge',
    '✨ Pistachio Raspberry'
  ];
  var state = {
    step: 0,
    steps: [],
    variantId: null,
    basePrice: 0,
    sizeName: '',
    flavor: '',
    flavorPrice: 0,
    /* Multi-flavor support:
       - 2-Tier cakes get 2 flavor slots (bottom + top)
       - Bento Flight gets 4 flavor slots (one per bento)
       - Everything else uses just state.flavor (single)
       state.flavors is the canonical multi-flavor array. state.flavor
       still holds the FIRST pick for backward compat (price calculation,
       cart property fallback, etc.). state.flavorSlot tracks which slot
       the customer is actively picking. */
    flavors: [],
    flavorPrices: [],
    flavorSlot: 0,
    noGF: false,
    hasNuts: false,
    diet: { gf: false, nut: false },
    nutAcknowledged: false,
    gfAcknowledged: false,
    /* For each slot, state.colors[slot] holds either:
       - 'Keep <originalName>' when customer keeps the photo color
       - A color name like 'Lavender' or 'Hot Pink'
       - 'Custom: #abc123' when customer used the custom picker
       The new replace flow makes "Like Image" obsolete — we now have
       per-slot "Keep <originalName>" instead. Single-color cakes still
       use 'Like Image' since they have no original-color metafield. */
    colors: {},
    customColorPrices: {},
    /* Which slot the customer is currently picking for. Drives the
       active outline, status banner, palette's pinned "Keep" swatch,
       and the auto-advance flow. */
    activeColorSlot: 1,
    photoUploaded: false,
    /* True once the customer taps "Looks perfect — lock it". The
       cropper is disabled while locked so accidental drags/pinches/
       scrolls can't move the approved position. Gate for the photo
       step's Next button. Reset on every new file upload. */
    photoLocked: false,
    photoFile: null,
    photoDataUrl: '',
    photoUrl: '',
    photoUrlWidth: 0,
    photoUrlHeight: 0,
    photoCropData: null,
    photoCropReady: false,
    photoPendingCanvas: null,
    cropperInstance: null,
    bgColor: '',
    message: '',
    cakeNumber: '',
    piping: { enabled: false, color: '' },
    sprinkle: { key: '', name: '', price: 0 },
    letterStyle: '',
    letterColor: '',
    letterColorCustomHex: '',
    letterColorCustomFee: 0,
    nakedChoice: '',
    bowColor: '',
    flowerColor: '',
    gender: '',
    /* Pearl decoration pick — one of: 'White', 'Gold', 'Silver',
       'None', or '' (not yet chosen). Only relevant on cakes where
       cfg.cakeHasPearls is true. No price impact. */
    pearlChoice: '',
    accent1: {},
    accent2: {},
    msgLines: { l1: '', l2: '', l3: '' },
    msgFreeform: '',
    extraMessage: '',
    candles: {
      selected: false,
      types: {
        rainbow:   { active: false },
        sparklers: { active: false },
        metallic:  { active: false, color: '' },
        number:    { active: false, color: '', number: '' }
      }
    },
    gift: { selected: false, text: '' },
    extras: {
      bow:      { selected: false, price: 5.25 },
      server:   { selected: false, price: 2.00 },
      coldpack: { selected: false, price: 3.00 }
    },
    flavorSearch: '',
    flavorFilter: 'all'
  };

  var CLOUDINARY_CLOUD  = 'dlocffoio';
  var CLOUDINARY_PRESET = 'dbakers_cake_photos';
  var CLOUDINARY_URL    = 'https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload';

  /* Debug logging — silenced in production by default. Flip on by
     running `window.ddbDebug = true` in the console. */
  function dlog() {
    if (!window.ddbDebug) return;
    console.log.apply(console, arguments);
  }
  function dwarn() {
    if (!window.ddbDebug) return;
    console.warn.apply(console, arguments);
  }

  /* ── Character limit tables ── */
  var CHAR_LIMITS = {
    groovy:  { fun: [5, 8, 5],  medium: [6, 9, 6],  large: [9, 12, 9] },
    fondant: { mini: [5, 4],    fun: [4, 6, 4],  medium: [5, 7, 5],  large: [7, 9, 7] }
  };
  var MINI_CURSIVE_BLOCK_MAX = 15;

  /* ── Replace-flow helpers ──
     Multi-color cakes (color_count >= 2) use the new "Replace pink →
     Lavender" flow. Single-color cakes keep their existing UI.
     useReplaceFlow() centralises that decision. */
  function useReplaceFlow() {
    return cfg.hasColors && (cfg.colorCount || 1) >= 2;
  }

  /* The original color name + hex for a given slot, as defined by the
     product's color_slot_labels + color_slot_hexes metafields. Returns
     null if not configured (cake hasn't been migrated yet) — callers
     should fall back to generic "Color N" wording. */
  function slotOriginal(slot) {
    var labels = cfg.colorSlotLabelsArr || [];
    var hexes  = cfg.colorSlotHexesArr  || [];
    var idx = parseInt(slot, 10) - 1;
    if (idx < 0) return null;
    var name = labels[idx];
    var hex  = hexes[idx];
    if (!name) return null;
    return { name: name, hex: hex || '#cccccc' };
  }

  function sizeKeyFor(title) {
    if (!title) return 'medium';
    if (window.ddbProduct && window.ddbProduct.isMini) return 'mini';
    var t = title.toLowerCase();
    if (t.indexOf('2-tier') === 0 || t.indexOf('2 tier') === 0) return 'tier';
    if (t.indexOf('fun size') > -1)  return 'fun';
    if (t.indexOf('large') > -1)     return 'large';
    if (t.indexOf('medium') > -1)    return 'medium';
    return 'medium';
  }

  function buildSteps() {
    var s = [];
    if (cfg.isMini) {
      s.push('mini-intro');
    } else {
      if (cfg.hasNakedOption)  s.push('naked');
      s.push('size');
    }
    /* Gender reveal cakes — pick before diet/flavor so the flavor list can
       adapt: pink/blue/letter = restricted to vanilla-friendly flavors
       (because of the dye); "no gender colors inside" = full flavor list. */
    if (window.ddbProduct && window.ddbProduct.showsGenderStep) s.push('gender');
    /* Dietary preferences shown BEFORE flavor so we can filter the flavor
       list to only what's compatible (GF customers don't see Red Velvet,
       nut-allergy customers don't see Nutella/Pistachio/Carrot, etc.) */
    s.push('diet');
    s.push('flavor');
    if (cfg.hasColors && state.nakedChoice !== 'naked')  s.push('color');
    if (cfg.hasBowColor)     s.push('bow-color');
    if (cfg.hasFlowerColor)  s.push('flower-color');
    if (cfg.cakeHasPearls)   s.push('pearls');
    if (cfg.accent1Label)    s.push('accent1');
    if (cfg.accent2Label)    s.push('accent2');
    if (cfg.hasPhotoUpload)  s.push('photo');
    if (cfg.hasSprinkles)    s.push('sprinkles');
    if (!cfg.hideMessage)    s.push('message');
    if (document.getElementById('ddb-step-calendar-date')) s.push('calendar-date');
    if (document.getElementById('ddb-step-polaroids')) s.push('polaroids');
    if (cfg.hasNumber)       s.push('number');
    s.push('review');
    state.steps = s;
  }

  function showCartError(msg) {
    var banner = document.getElementById('ddb-cart-error');
    var msgEl  = document.getElementById('ddb-cart-error-msg');
    if (!banner || !msgEl) return;
    msgEl.textContent = msg || 'Something went wrong adding to cart. Please try again.';
    banner.classList.add('is-visible');
    banner.setAttribute('aria-hidden', 'false');
    banner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function hideCartError() {
    var banner = document.getElementById('ddb-cart-error');
    if (!banner) return;
    banner.classList.remove('is-visible');
    banner.setAttribute('aria-hidden', 'true');
  }

  function init() {
    if (!document.getElementById('ddb-root')) return;
    function safe(name, fn) {
      try { fn(); }
      catch (err) { console.error('[ddb] ' + name + ' failed:', err); }
    }
    safe('buildSteps',              buildSteps);
    safe('setInitialVariant',       setInitialVariant);
    safe('bindSizeCards',           bindSizeCards);
    safe('bindFlavorList',          bindFlavorList);
    safe('bindFlavorSearch',        bindFlavorSearch);
    safe('bindFlavorFilters',       bindFlavorFilters);
    safe('bindDietCards',           bindDietCards);
    safe('bindNutAck',              bindNutAck);
    safe('bindGfAck',               bindGfAck);
    safe('bindVeganCard',           bindVeganCard);
    safe('bindColorSwatches',       bindColorSwatches);
    safe('bindColorPickers',        bindColorPickers);
    safe('bindReplaceSlots',        bindReplaceSlots);
    safe('bindUseAsShown',          bindUseAsShown);
    safe('bindPipingToggle',        bindPipingToggle);
    safe('bindPipingSwatches',      bindPipingSwatches);
    safe('bindSprinkleCards',       bindSprinkleCards);
    safe('bindNakedCards',          bindNakedCards);
    safe('bindBowColorSwatches',    bindBowColorSwatches);
    safe('bindFlowerColorSwatches', bindFlowerColorSwatches);
    safe('bindGenderCards',         bindGenderCards);
    safe('bindPearlSwatches',       bindPearlSwatches);
    safe('bindAccentSwatches',      bindAccentSwatches);
    safe('bindPhotoUpload',         bindPhotoUpload);
    safe('bindBgColorSwatches',     bindBgColorSwatches);
    safe('bindLetterStyles',        bindLetterStyles);
    safe('bindLetterColors',        bindLetterColors);
    safe('bindLetterColorPicker',   bindLetterColorPicker);
    safe('bindMessageInput',        bindMessageInput);
    safe('bindSkipMessage',         bindSkipMessage);
    safe('bindSumEditBtns',         bindSumEditBtns);
    safe('bindAddonRows',           bindAddonRows);
    safe('bindCandleTypes',         bindCandleTypes);
    safe('bindImageTiles',          bindImageTiles);
    safe('bindExtraCards',          bindExtraCards);
    safe('bindNavButtons',          bindNavButtons);
    safe('updateNav',               updateNav);
    safe('updatePrice',             updatePrice);
    /* Initialize the active slot on first paint so the palette shows
       the correct "Keep" pin and the slot row has the right outline. */
    if (useReplaceFlow()) {
      safe('setActiveReplaceSlot', function () { setActiveReplaceSlot(1); });
    }
    /* Preselect default flower color (per-handle hardcode in Liquid).
       The DOM already has is-selected on the matching card from the
       Liquid render — we just need to mirror it in state so the
       review summary, cart properties, and validation all reflect
       the default without the customer touching the step. */
    if (cfg.defaultFlowerColor) {
      state.flowerColor = cfg.defaultFlowerColor;
    }
  }

  if (document.readyState === 'complete') {
    setTimeout(init, 300);
  } else {
    window.addEventListener('load', function () { setTimeout(init, 300); });
  }

  function hydrateFromJson(handle, targetVariants, targetPrices) {
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (prod) {
        if (!prod || !prod.variants) return;
        prod.variants.forEach(function (v) {
          window[targetVariants] = window[targetVariants] || {};
          window[targetPrices]   = window[targetPrices]   || {};
          window[targetVariants][v.title] = v.id;
          window[targetPrices][v.title]   = v.price;
        });
        dlog('[ddb] Hydrated', prod.variants.length, 'variants from /products/' + handle + '.js');
      })
      .catch(function (err) {
        dwarn('[ddb] Could not hydrate from /products/' + handle + '.js:', err.message);
      });
  }

  (function runtimeHydration() {
    if (!window.ddbOptionVariants || Object.keys(window.ddbOptionVariants).length === 0) {
      dlog('[ddb] ddbOptionVariants empty after Liquid — fetching at runtime.');
      hydrateFromJson('heart-cake-custom-options', 'ddbOptionVariants', 'ddbOptionPrices');
    }
    if (!window.ddbFlavorVariants || Object.keys(window.ddbFlavorVariants).length === 0) {
      dlog('[ddb] ddbFlavorVariants empty after Liquid — fetching at runtime.');
      hydrateFromJson('designer_-_heart_cake_flavors', 'ddbFlavorVariants', 'ddbFlavorPrices');
    }
  })();

  function setInitialVariant() {
    if (cfg.isMini) {
      var hidden = document.getElementById('ddb-variant-id');
      if (!hidden) return;
      state.variantId = hidden.value;
      state.basePrice = parseFloat(hidden.dataset.variantPrice || '0') / 100;
      state.sizeName  = hidden.dataset.variantTitle || '';
      updatePrice();
      return;
    }
    /* Honor any selection the Liquid template pre-rendered (e.g. when
       cake_size_in_image is set, the pictured card ships with the
       is-selected class). Only fall back to the first card if nothing
       was preselected server-side. Without this guard, the JS would
       overwrite the Liquid pick and force "Fun Size" every time. */
    var preselected = document.querySelector('.ddb-size-card.is-selected:not([disabled])');
    var first = preselected
             || document.querySelector('.ddb-size-card:not([disabled])')
             || document.querySelector('.ddb-size-card');
    if (!first) return;
    document.querySelectorAll('.ddb-size-card').forEach(function (c) {
      c.classList.remove('is-selected');
      c.setAttribute('aria-checked', 'false');
    });
    first.classList.add('is-selected');
    first.setAttribute('aria-checked', 'true');
    state.variantId = first.dataset.variantId;
    state.basePrice = parseFloat(first.dataset.variantPrice) / 100;
    state.sizeName  = first.dataset.variantTitle;
    syncVariantInput();
    updatePrice();
  }

  function currentStepId() { return state.steps[state.step]; }
  function totalSteps()    { return state.steps.length; }

  function goStep(n) {
    if (n < 0) n = 0;
    if (n >= state.steps.length) n = state.steps.length - 1;

    var prevEl = document.getElementById('ddb-step-' + currentStepId());
    if (prevEl) prevEl.classList.remove('is-active');
    state.step = n;
    var nextEl = document.getElementById('ddb-step-' + currentStepId());
    if (nextEl) nextEl.classList.add('is-active');
    if (currentStepId() === 'diet') refreshDietStep();
    /* When the customer reaches the flavor step:
         1. Refresh visibility so dietary filters hide disallowed flavors
         2. If we're in multi-flavor mode (2-tier OR Bento Flight), reset
            the active slot to the first unfilled one (or 0) and render
            the slot cards + shortcut. */
    if (currentStepId() === 'flavor') {
      refreshFlavorVisibility();
      var slotCount = flavorSlotCount();
      if (slotCount > 1) {
        /* Resume on the first empty slot, or stay where they were if all
           are filled (rare — back-nav case). */
        var firstEmpty = -1;
        for (var fi = 0; fi < slotCount; fi++) {
          if (!state.flavors[fi]) { firstEmpty = fi; break; }
        }
        state.flavorSlot = (firstEmpty === -1) ? Math.min(state.flavorSlot, slotCount - 1) : firstEmpty;
        renderFlavorSlotCards();
        updateSameAsPreviousShortcut();
      } else {
        /* Single-flavor mode — make sure slot cards aren't lingering. */
        var step = document.getElementById('ddb-step-flavor');
        if (step) {
          var slots = step.querySelector('.ddb-flavor-slots');
          if (slots) slots.style.display = 'none';
          var shortcut = step.querySelector('.ddb-flavor-same-shortcut');
          if (shortcut && shortcut.parentNode) shortcut.parentNode.removeChild(shortcut);
        }
      }
    }
    /* When the customer reaches the color step (forward or back), make
       sure the active slot has the right visual + palette context. */
    if (currentStepId() === 'color' && useReplaceFlow()) {
      setActiveReplaceSlot(findFirstEmptySlot() || state.activeColorSlot || 1);
    }
    updateNav();
    updateSummary();

    if (nextEl) {
      var titleEl = nextEl.querySelector('.ddb-step-title') || nextEl;
      var rect = titleEl.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var headerOffset = 80;
      var isVisible = rect.top >= headerOffset && rect.top <= (viewportH * 0.8);
      if (!isVisible) {
        var targetTop = rect.top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: targetTop, behavior: 'smooth' });
      }
    }
  }

  function updateNav() {
    var n      = state.step;
    var total  = totalSteps();
    var stepId = currentStepId();
    var isLast = (n === total - 1);

    var progStep  = document.getElementById('ddb-prog-step');
    var progTitle = document.getElementById('ddb-prog-title');
    var progFill  = document.getElementById('ddb-prog-fill');
    var stepAnnounce = document.getElementById('ddb-step-announce');
    var pct = Math.round(((n + 1) / total) * 100);
    if (progStep)  progStep.textContent  = 'Step ' + (n + 1) + ' of ' + total;
    if (progTitle) progTitle.textContent = getStepTitle(stepId);
    if (progFill)  progFill.style.width  = pct + '%';
    if (stepAnnounce) stepAnnounce.textContent = 'Step ' + (n + 1) + ' of ' + total + ': ' + getStepTitle(stepId);

    var back = document.getElementById('ddb-btn-back');
    var next = document.getElementById('ddb-btn-next');
    var atc  = document.getElementById('ddb-btn-atc');
    if (back) back.classList.toggle('ddb-hidden', n === 0);
    if (next) next.classList.toggle('ddb-hidden', isLast);
    if (atc)  atc.classList.toggle('ddb-hidden', !isLast);
  }

  var stepTitles = {
    size: 'Size', flavor: 'Flavor', diet: 'Dietary',
    color: 'Color', photo: 'Photo',
    sprinkles: 'Sprinkles',
    naked: 'Style',
    'bow-color': 'Bow color',
    'flower-color': 'Flower color',
    pearls: 'Pearls',
    accent1: 'Accent color',
    accent2: 'Accent color',
    number: 'Number',
    'calendar-date': 'Date & message',
    message: 'Message', review: 'Review & Add to Cart'
  };

  function getStepTitle(id) {
    if (id === 'accent1' && cfg.accent1Label) return cfg.accent1Label;
    if (id === 'accent2' && cfg.accent2Label) return cfg.accent2Label;
    if (id === 'number' && cfg.numberLabel) return cfg.numberLabel;
    return stepTitles[id] || '';
  }

  function bindNavButtons() {
    var back = document.getElementById('ddb-btn-back');
    if (back) {
      back.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (state.step > 0) goStep(state.step - 1);
      });
    }
    var next = document.getElementById('ddb-btn-next');
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (validateStep()) goStep(state.step + 1);
      });
    }
    var atc = document.getElementById('ddb-btn-atc');
    if (atc) {
      atc.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        hideCartError();
        submitCart();
      });
    }
    var errClose = document.getElementById('ddb-cart-error-close');
    if (errClose) {
      errClose.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        hideCartError();
      });
    }
  }

  function bindSizeCards() {
    document.querySelectorAll('.ddb-size-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (this.disabled) return;
        document.querySelectorAll('.ddb-size-card').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.variantId = this.dataset.variantId;
        state.basePrice = parseFloat(this.dataset.variantPrice) / 100;
        var prevSize = state.sizeName;
        state.sizeName  = this.dataset.variantTitle;
        /* If switching INTO or OUT OF 2-Tier, reset the flavor slot picks
           since the required slot count changes (1 ↔ 2). */
        var wasTier = /2-tier/i.test(prevSize || '');
        var nowTier = /2-tier/i.test(state.sizeName || '');
        if (wasTier !== nowTier) {
          state.flavors = [];
          state.flavorPrices = [];
          state.flavorSlot = 0;
          state.flavor = '';
          state.flavorPrice = 0;
          state.noGF = false;
          state.hasNuts = false;
        }
        syncVariantInput();
        refreshLetterStyleAvailability();
        applyCharLimits();
        updatePrice();
        if (currentStepId() === 'size') setTimeout(function () {
          if (validateStep()) goStep(state.step + 1);
        }, 220);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function isGfBlocked()   { return state.noGF    || !!cfg.productNoGF; }
  function isNutsBlocked() { return state.hasNuts || !!cfg.productContainsNuts; }

  /* ────────── Multi-flavor helpers ──────────
     Two cases trigger multi-flavor mode:
       (a) Bento Flight (handle === 'the-bento-flight') → 4 slots
       (b) Any cake where the picked variant is a 2-Tier size → 2 slots
     Otherwise (default) → 1 slot, behaves exactly like single-flavor. */
  function isFlightProduct() {
    var h = (window.ddbProduct && window.ddbProduct.handle) || '';
    return h === 'the-bento-flight';
  }
  function is2TierSize() {
    var s = (state.sizeName || '').toLowerCase();
    return s.indexOf('2-tier') !== -1;
  }
  function flavorSlotCount() {
    if (isFlightProduct()) return 4;
    if (is2TierSize()) return 2;
    return 1;
  }
  function flavorSlotLabel(idx, slotCount) {
    if (slotCount === 4) return 'Cake ' + (idx + 1) + ' of 4';
    if (slotCount === 2) return idx === 0 ? '🔽 Bottom tier' : '🔼 Top tier';
    return 'Flavor';
  }
  function flavorSlotShortLabel(idx, slotCount) {
    if (slotCount === 4) return 'Cake ' + (idx + 1);
    if (slotCount === 2) return idx === 0 ? '🔽 Bottom' : '🔼 Top';
    return 'Flavor';
  }

  function bindFlavorList() {
    document.querySelectorAll('.ddb-flavor-item').forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var pickedFlavor = this.dataset.flavor;
        var pickedPrice  = parseInt(this.dataset.price, 10) / 100 || 0;
        var slotCount = flavorSlotCount();

        /* Multi-flavor mode: record the pick into the active slot, advance
           slot counter, and either stay on flavor step (more slots) or
           proceed normally (all slots filled). */
        if (slotCount > 1) {
          state.flavors[state.flavorSlot] = pickedFlavor;
          state.flavorPrices[state.flavorSlot] = pickedPrice;
          /* state.flavor mirrors the FIRST pick for backward compatibility
             with existing code paths (price calc, summary, etc.). */
          if (state.flavorSlot === 0) {
            state.flavor = pickedFlavor;
            state.flavorPrice = pickedPrice;
            state.noGF    = NO_GF_FLAVORS.indexOf(state.flavor) > -1;
            state.hasNuts = NUT_FLAVORS.indexOf(state.flavor) > -1;
          }
          /* Re-render visual UI for slot cards. */
          renderFlavorSlotCards();
          updatePrice();
          /* If there are more slots, advance to the next slot WITHOUT
             leaving the flavor step. */
          if (state.flavorSlot + 1 < slotCount) {
            state.flavorSlot += 1;
            renderFlavorSlotCards();
            updateSameAsPreviousShortcut();
            /* Visually deselect all items so customer sees a fresh pick. */
            document.querySelectorAll('.ddb-flavor-item').forEach(function (i) {
              i.classList.remove('is-selected');
              i.setAttribute('aria-selected', 'false');
            });
            return;
          }
          /* All slots filled — proceed to next step like normal. */
          if (currentStepId() === 'flavor') setTimeout(function () {
            if (validateStep()) goStep(state.step + 1);
          }, 220);
          return;
        }

        /* Single-flavor mode — original behavior. */
        document.querySelectorAll('.ddb-flavor-item').forEach(function (i) {
          i.classList.remove('is-selected');
          i.setAttribute('aria-selected', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-selected', 'true');
        state.flavor      = pickedFlavor;
        state.flavorPrice = pickedPrice;
        state.flavors = [pickedFlavor];
        state.flavorPrices = [pickedPrice];
        state.noGF    = NO_GF_FLAVORS.indexOf(state.flavor) > -1;
        state.hasNuts = NUT_FLAVORS.indexOf(state.flavor) > -1;
        if (isGfBlocked()) {
          state.diet.gf = false;
          state.gfAcknowledged = false;
        }
        if (isNutsBlocked()) {
          state.diet.nut = false;
          state.nutAcknowledged = false;
        }
        updatePrice();
        if (currentStepId() === 'flavor') setTimeout(function () {
          if (validateStep()) goStep(state.step + 1);
        }, 220);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function refreshFlavorVisibility() {
    var q = (state.flavorSearch || '').toLowerCase();
    var filter = state.flavorFilter || 'all';
    var nakedOnly = (state.nakedChoice === 'naked');
    /* Dietary filters — when GF is selected, hide flavors that can't be
       made gluten-free (Red Velvets). When nut allergy is selected, hide
       flavors containing nuts (Carrot, Nutella, Pistachio). The customer
       picked their restrictions first, so these flavors aren't options. */
    var hideNoGF  = !!(state.diet && state.diet.gf);
    var hideNuts  = !!(state.diet && state.diet.nut);

    document.querySelectorAll('.ddb-flavor-item').forEach(function (item) {
      var rawName = item.dataset.flavor || '';
      var name = rawName.toLowerCase();
      var category = item.dataset.category || '';
      var nakedOk = item.dataset.nakedOk === 'true';

      var matchesSearch = !q || name.indexOf(q) !== -1;
      var matchesFilter = (filter === 'all') || (category === filter);
      var matchesNaked  = !nakedOnly || nakedOk;
      var matchesDiet   = true;
      if (hideNoGF && NO_GF_FLAVORS.indexOf(rawName) !== -1) matchesDiet = false;
      if (hideNuts && NUT_FLAVORS.indexOf(rawName)   !== -1) matchesDiet = false;

      item.style.display = (matchesSearch && matchesFilter && matchesNaked && matchesDiet) ? '' : 'none';
    });
  }

  function bindFlavorSearch() {
    var input = document.getElementById('ddb-flavor-search');
    if (!input) return;
    input.addEventListener('input', function () {
      state.flavorSearch = this.value;
      refreshFlavorVisibility();
    });
  }

  /* ────────── Multi-flavor slot UI ──────────
     Renders the row of slot cards at the top of the flavor step (Bottom/Top
     for 2-tier, Cake 1-4 for Bento Flight). The active slot is highlighted
     purple; completed slots show their picked flavor; future slots show
     "Next up" or are blank.

     The container .ddb-flavor-slots is created on-the-fly if it doesn't
     exist (no Liquid changes needed). */
  function ensureFlavorSlotContainer() {
    var step = document.getElementById('ddb-step-flavor');
    if (!step) return null;
    var existing = step.querySelector('.ddb-flavor-slots');
    if (existing) return existing;
    var container = document.createElement('div');
    container.className = 'ddb-flavor-slots';
    /* Insert AFTER the step title/subtitle, BEFORE the search bar. */
    var anchor = step.querySelector('.ddb-search-wrap') ||
                 step.querySelector('.ddb-filter-pills') ||
                 step.querySelector('.ddb-flavor-list');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(container, anchor);
    } else {
      step.appendChild(container);
    }
    return container;
  }

  function renderFlavorSlotCards() {
    var slotCount = flavorSlotCount();
    var container = ensureFlavorSlotContainer();
    if (!container) return;
    if (slotCount <= 1) {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }
    container.style.display = '';

    /* Build a notice + grid of cards. */
    var notice = '';
    if (slotCount === 2) {
      notice = '<div class="ddb-flavor-slots-notice">' +
        '<strong>🍰 You picked a 2-tier cake.</strong> Choose the bottom tier flavor first, then the top.' +
      '</div>';
    } else if (slotCount === 4) {
      notice = '<div class="ddb-flavor-slots-notice">' +
        '<strong>✨ Bento Flight.</strong> Pick a flavor for each of the 4 bento cakes.' +
      '</div>';
    }

    var gridCols = (slotCount === 4) ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)';
    var cardsHtml = '<div class="ddb-flavor-slots-grid" style="grid-template-columns:' + gridCols + ';">';
    for (var i = 0; i < slotCount; i++) {
      var label    = flavorSlotShortLabel(i, slotCount);
      var picked   = state.flavors[i] || '';
      var isActive = (i === state.flavorSlot);
      var isDone   = !!picked;
      var stateCls = isActive ? 'is-active' : (isDone ? 'is-done' : 'is-pending');
      var topText  = isActive ? 'Picking now' : (isDone ? 'Picked' : 'Up next');
      var bodyText = picked || label;
      /* Clicking a completed card jumps back to that slot to re-pick. */
      cardsHtml += '<button type="button" class="ddb-flavor-slot ' + stateCls + '" data-slot="' + i + '">' +
        '<div class="ddb-flavor-slot-status">' + topText + '</div>' +
        '<div class="ddb-flavor-slot-body">' +
          '<span class="ddb-flavor-slot-icon">' + label + '</span>' +
          (picked ? '<span class="ddb-flavor-slot-name">' + picked + '</span>' : '') +
        '</div>' +
      '</button>';
    }
    cardsHtml += '</div>';

    container.innerHTML = notice + cardsHtml;

    /* Wire slot click — jump back to re-pick that slot. */
    container.querySelectorAll('.ddb-flavor-slot').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var slot = parseInt(this.dataset.slot, 10);
        if (isNaN(slot)) return;
        state.flavorSlot = slot;
        renderFlavorSlotCards();
        updateSameAsPreviousShortcut();
        /* Visually highlight the currently-picked flavor for this slot, if any. */
        document.querySelectorAll('.ddb-flavor-item').forEach(function (i) {
          i.classList.remove('is-selected');
          i.setAttribute('aria-selected', 'false');
          if (i.dataset.flavor === state.flavors[slot]) {
            i.classList.add('is-selected');
            i.setAttribute('aria-selected', 'true');
          }
        });
      });
    });
  }

  /* "Same as previous" purple shortcut that appears below the slot cards
     starting on slot 2+ (so customer can quickly replicate a previous pick). */
  function updateSameAsPreviousShortcut() {
    var step = document.getElementById('ddb-step-flavor');
    if (!step) return;
    var existing = step.querySelector('.ddb-flavor-same-shortcut');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var slotCount = flavorSlotCount();
    if (slotCount <= 1) return;
    if (state.flavorSlot === 0) return;
    var prev = state.flavors[state.flavorSlot - 1];
    if (!prev) return;

    var shortcut = document.createElement('div');
    shortcut.className = 'ddb-color-disclaimer ddb-flavor-same-shortcut';
    shortcut.style.cssText = 'background:#f0e8f8;color:#4a2a60;margin-top:10px;cursor:pointer;';
    shortcut.innerHTML = '💡 Want the same flavor as ' + flavorSlotShortLabel(state.flavorSlot - 1, slotCount).replace(/[🔽🔼]/g, '').trim() +
      '? <strong style="text-decoration:underline;">Use ' + prev + ' for ' + flavorSlotShortLabel(state.flavorSlot, slotCount).replace(/[🔽🔼]/g, '').trim() + ' too →</strong>';
    shortcut.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      /* Simulate clicking the previous flavor's tile so the same pick path runs. */
      var prevPrice = state.flavorPrices[state.flavorSlot - 1] || 0;
      state.flavors[state.flavorSlot] = prev;
      state.flavorPrices[state.flavorSlot] = prevPrice;
      renderFlavorSlotCards();
      updatePrice();
      if (state.flavorSlot + 1 < slotCount) {
        state.flavorSlot += 1;
        renderFlavorSlotCards();
        updateSameAsPreviousShortcut();
        document.querySelectorAll('.ddb-flavor-item').forEach(function (i) {
          i.classList.remove('is-selected');
          i.setAttribute('aria-selected', 'false');
        });
      } else {
        if (currentStepId() === 'flavor') setTimeout(function () {
          if (validateStep()) goStep(state.step + 1);
        }, 220);
      }
    });

    var slotsContainer = step.querySelector('.ddb-flavor-slots');
    if (slotsContainer && slotsContainer.parentNode) {
      slotsContainer.parentNode.insertBefore(shortcut, slotsContainer.nextSibling);
    }
  }

  function bindFlavorFilters() {
    document.querySelectorAll('#ddb-step-flavor .ddb-pill').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('#ddb-step-flavor .ddb-pill').forEach(function (p) {
          p.classList.remove('is-active');
        });
        this.classList.add('is-active');
        state.flavorFilter = this.dataset.filter;
        refreshFlavorVisibility();
      });
    });
  }

  function bindDietCards() {
    document.querySelectorAll('.ddb-diet-card').forEach(function (card) {
      if (card.id === 'ddb-vegan-card') return;
      card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (this.classList.contains('is-unavailable')) return;
        var diet = this.dataset.diet;
        if (!diet) return;
        var isSelected = this.classList.contains('is-selected');
        this.classList.toggle('is-selected', !isSelected);
        this.setAttribute('aria-checked', String(!isSelected));

        if (diet === 'gf') {
          state.diet.gf = !isSelected;
          state.gfAcknowledged = false;
          var gfWarn = document.getElementById('ddb-gf-warning');
          var gfBox  = document.getElementById('ddb-gf-box');
          var gfReview = document.getElementById('ddb-gf-review');
          if (gfWarn) gfWarn.classList.toggle('is-visible', state.diet.gf);
          if (gfReview) gfReview.classList.toggle('is-visible', state.diet.gf);
          if (gfBox) gfBox.classList.remove('is-checked');
        }
        if (diet === 'nut') {
          state.diet.nut = !isSelected;
          state.nutAcknowledged = false;
          var nutWarn = document.getElementById('ddb-nut-warning');
          var nutBox  = document.getElementById('ddb-nut-box');
          if (nutWarn) nutWarn.classList.toggle('is-visible', state.diet.nut);
          if (nutBox) nutBox.classList.remove('is-checked');
        }
        /* If the customer already had a flavor picked and the new dietary
           restriction excludes it, clear the choice so they can re-pick. */
        if (state.flavor) {
          if (state.diet.gf && NO_GF_FLAVORS.indexOf(state.flavor) !== -1) {
            state.flavor = '';
            state.flavorPrice = 0;
            state.noGF = false;
          }
          if (state.diet.nut && NUT_FLAVORS.indexOf(state.flavor) !== -1) {
            state.flavor = '';
            state.flavorPrice = 0;
            state.hasNuts = false;
          }
        }
        /* Refresh the flavor list so disallowed flavors hide immediately. */
        refreshFlavorVisibility();
        updatePrice();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });

    var skip = document.getElementById('ddb-diet-skip');
    if (skip) {
      skip.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        state.diet.gf = false;
        state.diet.nut = false;
        state.nutAcknowledged = false;
        state.gfAcknowledged = false;
        document.querySelectorAll('.ddb-diet-card').forEach(function (c) {
          if (c.id === 'ddb-vegan-card') return;
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        var nutWarn = document.getElementById('ddb-nut-warning');
        if (nutWarn) nutWarn.classList.remove('is-visible');
        var gfWarn = document.getElementById('ddb-gf-warning');
        if (gfWarn) gfWarn.classList.remove('is-visible');
        var gfReviewClear = document.getElementById('ddb-gf-review');
        if (gfReviewClear) gfReviewClear.classList.remove('is-visible');
        /* Clearing dietary restrictions means all flavors are visible again. */
        refreshFlavorVisibility();
        updatePrice();
        if (validateStep()) goStep(state.step + 1);
      });
    }
  }

  function bindNutAck() {
    var ack = document.getElementById('ddb-nut-ack');
    if (!ack) return;
    function handleNutAck(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      state.nutAcknowledged = !state.nutAcknowledged;
      var box = document.getElementById('ddb-nut-box');
      if (box) box.classList.toggle('is-checked', state.nutAcknowledged);
      ack.setAttribute('aria-checked', String(state.nutAcknowledged));
    }
    ack.addEventListener('mousedown',  handleNutAck);
    ack.addEventListener('touchstart', handleNutAck, { passive: false });
    ack.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleNutAck(e); }
    });
  }

  function bindGfAck() {
    var ack = document.getElementById('ddb-gf-ack');
    if (!ack) return;
    function handleGfAck(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      state.gfAcknowledged = !state.gfAcknowledged;
      var box = document.getElementById('ddb-gf-box');
      if (box) box.classList.toggle('is-checked', state.gfAcknowledged);
      ack.setAttribute('aria-checked', String(state.gfAcknowledged));
    }
    ack.addEventListener('mousedown',  handleGfAck);
    ack.addEventListener('touchstart', handleGfAck, { passive: false });
    ack.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleGfAck(e); }
    });
  }

  function bindVeganCard() {
    var card  = document.getElementById('ddb-vegan-card');
    var panel = document.getElementById('ddb-vegan-panel');
    if (!card || !panel) return;
    function handleVegan(e) {
      e.preventDefault(); e.stopPropagation();
      var isOpen = card.classList.contains('is-expanded');
      card.classList.toggle('is-expanded', !isOpen);
      panel.classList.toggle('is-visible', !isOpen);
      panel.setAttribute('aria-hidden', String(isOpen));
      card.setAttribute('aria-expanded', String(!isOpen));
    }
    card.addEventListener('mousedown',  handleVegan);
    card.addEventListener('touchstart', handleVegan, { passive: false });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleVegan(e); }
    });
  }

  function refreshDietStep() {
    var gfCard   = document.getElementById('ddb-gf-card');
    var nutCard  = document.getElementById('ddb-nut-card');
    var gfPrice  = document.getElementById('ddb-gf-price');
    var nutPrice = document.getElementById('ddb-nut-price');
    var gfWarn   = document.getElementById('ddb-gf-warning');
    var nutWarn  = document.getElementById('ddb-nut-warning');

    if (gfCard) {
      if (isGfBlocked()) {
        gfCard.className = 'ddb-diet-card is-unavailable';
        gfCard.setAttribute('aria-checked', 'false');
        var gfReason = cfg.productNoGF ? 'Not available for this cake' : 'Not available for this flavor';
        if (gfPrice) gfPrice.innerHTML = '<span style="color:#b91c1c;font-size:10px;">' + gfReason + '</span>';
        if (gfWarn) gfWarn.classList.remove('is-visible');
        var gfReviewBlocked = document.getElementById('ddb-gf-review');
        if (gfReviewBlocked) gfReviewBlocked.classList.remove('is-visible');
      } else {
        gfCard.className = 'ddb-diet-card' + (state.diet.gf ? ' is-selected' : '');
        gfCard.setAttribute('aria-checked', String(state.diet.gf));
        if (gfPrice) gfPrice.textContent = '+$15.00';
        if (gfWarn) gfWarn.classList.toggle('is-visible', state.diet.gf);
      }
    }
    if (nutCard) {
      if (isNutsBlocked()) {
        nutCard.className = 'ddb-diet-card is-unavailable';
        nutCard.setAttribute('aria-checked', 'false');
        var nutReason = cfg.productContainsNuts ? 'Contains nuts' : 'Contains nuts';
        if (nutPrice) nutPrice.innerHTML = '<span style="color:#b91c1c;font-size:10px;">' + nutReason + '</span>';
        if (nutWarn) nutWarn.classList.remove('is-visible');
      } else {
        nutCard.className = 'ddb-diet-card' + (state.diet.nut ? ' is-selected' : '');
        nutCard.setAttribute('aria-checked', String(state.diet.nut));
        if (nutPrice) nutPrice.textContent = 'No charge';
        if (nutWarn) nutWarn.classList.toggle('is-visible', state.diet.nut);
      }
    }
  }

  /* ════════════════════════════════════════════════════════════════
     REPLACE-COLOR FLOW (multi-color cakes, color_count >= 2)
     ════════════════════════════════════════════════════════════════ */

  /* Find the first slot that hasn't been picked yet. Used when
     entering the color step or after picking a color. Returns null
     if every slot has a value. */
  function findFirstEmptySlot() {
    var n = cfg.colorCount || 1;
    for (var i = 1; i <= n; i++) {
      if (!state.colors[i]) return i;
    }
    return null;
  }

  /* Bind clicks on the slot cards themselves. Tapping a slot makes
     it active — palette re-pins to that slot's "Keep" option and the
     status banner updates. Lets customers go back and change picks. */
  function bindReplaceSlots() {
    if (!useReplaceFlow()) return;
    document.querySelectorAll('.ddb-replace-slot').forEach(function (slotEl) {
      slotEl.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var slot = parseInt(this.dataset.slot, 10);
        if (slot) setActiveReplaceSlot(slot);
      });
      slotEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  /* Update the status banner ("Now replacing the pink") and the
     pinned "Keep <name>" swatch at the start of the palette. */
  function setActiveReplaceSlot(slot) {
    if (!useReplaceFlow()) return;
    var n = parseInt(slot, 10) || 1;
    if (n < 1) n = 1;
    if (n > (cfg.colorCount || 1)) n = cfg.colorCount || 1;
    state.activeColorSlot = n;

    /* Slot row outlines + per-slot copy */
    document.querySelectorAll('.ddb-replace-slot').forEach(function (el) {
      var s = parseInt(el.dataset.slot, 10);
      el.classList.toggle('is-active', s === n);
    });

    /* Status banner */
    var orig = slotOriginal(n);
    var banner = document.getElementById('ddb-replace-banner');
    var bannerSwatch = document.getElementById('ddb-replace-banner-swatch');
    var bannerText = document.getElementById('ddb-replace-banner-text');
    if (banner && bannerSwatch && bannerText) {
      if (orig) {
        bannerSwatch.style.background = orig.hex;
        /* If the slot has an element label (e.g. "Balloon number" or
           "Drip"), use it in place of the literal word "cake" so the
           customer sees what they're picking for. Falls back to "on
           the cake" when no element label is set — preserves today's
           copy for the default Two-Toned-Beauty-style cakes. */
        var slotEl = document.querySelector('.ddb-replace-slot[data-slot="' + n + '"]');
        var elementName = slotEl ? (slotEl.dataset.origElement || '') : '';
        var onWhat = elementName
          ? ('on the <strong>' + escapeHtml(elementName.toLowerCase()) + '</strong>')
          : 'on the cake';
        bannerText.innerHTML = 'Now replacing the <strong>' + escapeHtml(orig.name.toLowerCase()) + '</strong> ' + onWhat;
      } else {
        bannerSwatch.style.background = '#ccc';
        bannerText.innerHTML = 'Now picking <strong>Color ' + n + '</strong>';
      }
    }

    /* Repin the "Keep" swatch at the front of the palette. */
    refreshKeepSwatch();

    /* Sync palette selection state to the active slot's saved pick.
       Without this, the previously-active slot's swatch stays
       highlighted in the palette even after switching slots, making
       it look like multiple colors are selected at once. We clear
       all palette swatches, then re-mark the one (if any) matching
       what the new active slot already has stored. */
    document.querySelectorAll('#ddb-step-color .ddb-swatch').forEach(function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-checked', 'false');
    });
    var savedValue = state.colors[n];
    if (savedValue && typeof savedValue === 'string') {
      var matchSel;
      if (savedValue.indexOf('Keep ') === 0) {
        /* "Keep <name>" — refreshKeepSwatch() handles its own selection
           state, so we don't need to mark another swatch. */
        matchSel = null;
      } else if (savedValue.indexOf('Custom: ') === 0) {
        /* Custom pick — mark the Custom swatch. */
        matchSel = '#ddb-step-color .ddb-swatch[data-custom="true"]';
      } else {
        /* Normal palette color — match by name. */
        matchSel = '#ddb-step-color .ddb-swatch[data-color="' + savedValue.replace(/"/g, '\\"') + '"]';
      }
      if (matchSel) {
        var match = document.querySelector(matchSel);
        if (match) {
          match.classList.add('is-selected');
          match.setAttribute('aria-checked', 'true');
        }
      }
    }

    /* Show only the picker for the active slot. */
    document.querySelectorAll('.ddb-color-picker-wrap').forEach(function (pw) {
      var pwSlot = parseInt(pw.dataset.colorPickerSlot, 10);
      if (pwSlot !== n) pw.classList.remove('is-visible');
    });

    /* Hide any palette swatch whose name matches the active slot's
       original photo color — avoids the confusion of having two ways
       to express the same intent ("Keep white" + "Vanilla White"
       both produce the same visual result). The customer should use
       Keep to express "match the photo".
       Match by name (case-insensitive) rather than hex, so slight hex
       tweaks in either list don't break the dedup. When switching
       slots, all palette swatches are first revealed, then the new
       active slot's duplicate (if any) is hidden. */
    hidePaletteDuplicateForActiveSlot();
  }

  function hidePaletteDuplicateForActiveSlot() {
    /* First reset — show every palette swatch. We use a dedicated
       class (.ddb-swatch--hidden) instead of inline display:none
       because .ddb-swatch has `display: flex !important` in CSS
       which beats inline styles. The class rule uses !important too. */
    document.querySelectorAll('#ddb-step-color .ddb-swatch').forEach(function (sw) {
      if (sw.classList.contains('ddb-keep-swatch')) return;
      sw.classList.remove('ddb-swatch--hidden');
    });

    var slot = state.activeColorSlot;
    var orig = slotOriginal(slot);
    if (!orig || !orig.name) return;

    var targetName = orig.name.trim().toLowerCase();
    document.querySelectorAll('#ddb-step-color .ddb-swatch[data-color]').forEach(function (sw) {
      var swName = (sw.dataset.color || '').trim().toLowerCase();
      if (swName === targetName) {
        sw.classList.add('ddb-swatch--hidden');
      }
    });
  }

  /* The "Keep <name>" swatch lives at the very front of the palette.
     It updates whenever the active slot changes. */
  function refreshKeepSwatch() {
    var holder = document.getElementById('ddb-keep-swatch-holder');
    if (!holder) return;
    var slot = state.activeColorSlot;
    var orig = slotOriginal(slot);
    if (!orig) {
      holder.innerHTML = '';
      return;
    }
    var keepName = 'Keep ' + orig.name.toLowerCase();
    var stateVal = state.colors[slot];
    var isSelected = (typeof stateVal === 'string') && (stateVal === 'Keep ' + orig.name);
    var lightBorder = isLightHex(orig.hex);
    holder.innerHTML =
      '<div class="ddb-swatch ddb-keep-swatch' + (isSelected ? ' is-selected' : '') + '" ' +
      'data-keep-slot="' + slot + '" ' +
      'data-keep-original-name="' + escapeHtml(orig.name) + '" ' +
      'data-keep-original-hex="' + escapeHtml(orig.hex) + '" ' +
      'role="radio" aria-checked="' + (isSelected ? 'true' : 'false') + '" tabindex="0">' +
      '<div class="ddb-swatch-circle" style="background:' + orig.hex + ';' +
      (lightBorder ? 'border:1.5px solid rgba(0,0,0,0.15);' : '') + '" aria-hidden="true"></div>' +
      '<span class="ddb-swatch-name">' + escapeHtml(keepName) + '</span>' +
      '</div>';

    var sw = holder.querySelector('.ddb-keep-swatch');
    if (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        handleKeepSwatchClick(this);
      });
      sw.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    }
  }

  /* Treat "Keep" as a normal swatch pick — set state.colors[slot] to
     'Keep <originalName>', update the slot card, advance the slot. */
  function handleKeepSwatchClick(sw) {
    var slot = parseInt(sw.dataset.keepSlot, 10);
    var origName = sw.dataset.keepOriginalName;
    if (!slot || !origName) return;
    state.colors[slot] = 'Keep ' + origName;
    state.customColorPrices[slot] = 0;

    /* Clear regular palette selection — Keep is now the active one. */
    document.querySelectorAll('[data-color-slot="' + slot + '"]').forEach(function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-checked', 'false');
    });
    sw.classList.add('is-selected');
    sw.setAttribute('aria-checked', 'true');

    /* Close custom picker if it was open. */
    var picker = document.getElementById('ddb-color-picker-' + slot);
    if (picker) { picker.classList.remove('is-visible'); picker.setAttribute('aria-hidden', 'true'); }

    /* If this slot drives the letter color, reset to italic "we'll
       match" hint since "Keep" has no specific replacement hex. */
    if (cfg.letterColorMatchesColor && String(cfg.letterColorMatchesColor) === String(slot)) {
      applyLetterColorToInputs('', 'Like Image');
    }

    /* Update the slot card visuals. */
    renderReplaceSlot(slot);

    /* Clear "Just like the photo" active state if the customer is
       picking individual slots — they're now diverging from a one-tap
       choice. (Or keep it active if every slot is now Keep.) */
    var uas = document.getElementById('ddb-use-as-shown');
    if (uas) uas.classList.remove('is-active');

    updatePrice();
    advanceToNextSlot();
  }

  /* After picking for the current slot, find the next empty one and
     activate it. If everything's filled, just leave the current slot
     active so the customer can review what they picked. */
  function advanceToNextSlot() {
    var next = findFirstEmptySlot();
    if (next && next !== state.activeColorSlot) {
      setActiveReplaceSlot(next);
    } else {
      /* Still refresh the keep swatch so its selected state matches. */
      refreshKeepSwatch();
    }
  }

  /* Re-render a single slot card based on state.colors[slot]. Called
     after the customer picks, keeps, or clears a slot. */
  function renderReplaceSlot(slot) {
    var slotEl = document.querySelector('.ddb-replace-slot[data-slot="' + slot + '"]');
    if (!slotEl) return;
    var orig = slotOriginal(slot);
    var origName = orig ? orig.name : 'Color ' + slot;
    var origHex  = orig ? orig.hex  : '#cccccc';
    var stateVal = state.colors[slot];

    var newHex = '';
    var newLabel = '';
    var isKept = false;
    var isPicked = false;

    if (typeof stateVal === 'string' && stateVal.indexOf('Keep ') === 0) {
      isPicked = true;
      isKept = true;
      newHex = origHex;
      newLabel = origName;
    } else if (typeof stateVal === 'string' && stateVal.indexOf('Custom: ') === 0) {
      isPicked = true;
      newHex = stateVal.substring(8);
      newLabel = 'Custom';
    } else if (stateVal) {
      isPicked = true;
      newHex = hexForColorName(stateVal) || '#cccccc';
      newLabel = stateVal;
    }

    /* Slot inner HTML — keep it markup-light. The ✨ badge stays the
       responsibility of the Liquid template (only renders if this
       slot is the letter-match slot). */
    var lightOrig = isLightHex(origHex);
    var lightNew = newHex ? isLightHex(newHex) : false;
    var newSwatchHtml;
    if (isPicked) {
      newSwatchHtml =
        '<span class="ddb-replace-swatch ddb-replace-swatch--new" style="background:' + newHex + ';' +
        (lightNew ? 'border:1.5px solid rgba(0,0,0,0.18);' : '') + '"></span>';
    } else {
      newSwatchHtml =
        '<span class="ddb-replace-swatch ddb-replace-swatch--placeholder">+</span>';
    }

    var labelText = isPicked
      ? (isKept ? 'Keep ' + origName.toLowerCase() : newLabel)
      : origName;

    var arrowLabel = isPicked ? 'REPLACED WITH' : 'REPLACE WITH';
    if (isKept) arrowLabel = 'KEEP';

    var ledger = slotEl.querySelector('.ddb-replace-slot-body');
    if (!ledger) return;

    ledger.innerHTML =
      '<span class="ddb-replace-swatch ddb-replace-swatch--orig" ' +
      'style="background:' + origHex + ';' + (lightOrig ? 'border:1px solid rgba(0,0,0,0.18);' : '') + '">' +
      '<span class="ddb-replace-strike" aria-hidden="true"></span>' +
      '</span>' +
      '<span class="ddb-replace-arrow">↓ ' + arrowLabel + '</span>' +
      newSwatchHtml +
      '<span class="ddb-replace-label">' + escapeHtml(labelText) + '</span>';

    slotEl.classList.toggle('is-picked', isPicked);
    slotEl.classList.toggle('is-kept', isKept);
  }

  /* Resolve a color name to its hex value by looking it up in the
     palette swatches (data-bg attribute). Returns null if not found
     (e.g. for "Custom" or "Like Image"). */
  function hexForColorName(name) {
    if (!name) return null;
    var sw = document.querySelector('.ddb-swatch[data-color="' + name + '"][data-bg]');
    if (sw && sw.dataset.bg) return sw.dataset.bg;
    return null;
  }

  function isLightHex(hex) {
    if (!hex || hex.length < 4) return false;
    var h = hex.replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var r = parseInt(h.substring(0,2), 16);
    var g = parseInt(h.substring(2,4), 16);
    var b = parseInt(h.substring(4,6), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return false;
    /* Luminance threshold — same heuristic as the Liquid template. */
    return (0.299*r + 0.587*g + 0.114*b) > 220;
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function bindColorSwatches() {
    document.querySelectorAll('#ddb-step-color .ddb-swatch').forEach(function (swatch) {
      /* Skip background-color swatches (photo cakes), Keep swatches
         (handled separately in refreshKeepSwatch), and piping swatches
         (handled by bindPipingSwatches). Without this guard, clicking
         a piping swatch would fire BOTH handlers — piping handler sets
         piping color correctly, but the main color handler would also
         fire and reset state.colors[1] to the piping color. */
      if (swatch.dataset.bgColor) return;
      if (swatch.classList.contains('ddb-keep-swatch')) return;
      if (swatch.classList.contains('ddb-piping-swatch')) return;
      swatch.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        handlePaletteSwatchClick(this);
      });
      swatch.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function handlePaletteSwatchClick(sw) {
    /* In the replace flow, the swatch applies to state.activeColorSlot.
       In the single-color flow it applies to slot 1 (data-color-slot="1"). */
    var slot;
    if (useReplaceFlow()) {
      slot = state.activeColorSlot || 1;
    } else {
      slot = sw.dataset.colorSlot || '1';
    }

    /* Clear all palette + keep swatches' selected state. They share
       the global palette in the replace flow — only one wins. */
    document.querySelectorAll('#ddb-step-color .ddb-swatch').forEach(function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-checked', 'false');
    });
    sw.classList.add('is-selected');
    sw.setAttribute('aria-checked', 'true');

    var colorName = sw.dataset.color;
    state.colors[slot] = colorName;

    var isCustom = sw.dataset.custom === 'true';
    state.customColorPrices[slot] = isCustom ? 10 : 0;

    var picker = document.getElementById('ddb-color-picker-' + slot);
    if (picker) {
      picker.classList.toggle('is-visible', isCustom);
      picker.setAttribute('aria-hidden', String(!isCustom));
    }

    if (isCustom) {
      var pickerInput = document.getElementById('ddb-color-picker-input-' + slot);
      var seedHex = pickerInput ? pickerInput.value : '#c39bde';
      state.colors[slot] = 'Custom: ' + seedHex;
    }

    /* Letter-color inheritance — same as before. */
    if (cfg.letterColorMatchesColor && String(cfg.letterColorMatchesColor) === String(slot)) {
      if (isCustom) {
        var pickerVal = document.getElementById('ddb-color-picker-input-' + slot);
        applyLetterColorToInputs(pickerVal ? pickerVal.value : '', colorName);
      } else if (sw.dataset.bg) {
        applyLetterColorToInputs(sw.dataset.bg, colorName);
      }
    }

    /* Clear "Just like the photo" — customer is diverging. */
    var uas = document.getElementById('ddb-use-as-shown');
    if (uas) uas.classList.remove('is-active');

    if (useReplaceFlow()) {
      renderReplaceSlot(slot);
      updatePrice();
      /* Don't auto-advance when custom is selected — the customer needs
         to interact with the color picker first. */
      if (!isCustom) advanceToNextSlot();
    } else {
      /* Single-color flow — price updates, no preview bar to refresh. */
      updatePrice();
    }
  }

  function bindColorPickers() {
    document.querySelectorAll('.ddb-color-picker-input').forEach(function (input) {
      input.addEventListener('input', function () {
        var slot    = this.dataset.colorSlot;
        var hex     = this.value;
        var preview = document.getElementById('ddb-color-preview-' + slot);
        var hexEl   = document.getElementById('ddb-color-hex-' + slot);
        if (preview) preview.style.background = hex;
        if (hexEl)   hexEl.textContent = hex;
        state.colors[slot] = 'Custom: ' + hex;
        if (useReplaceFlow()) {
          renderReplaceSlot(parseInt(slot, 10));
        }
        if (cfg.letterColorMatchesColor && String(cfg.letterColorMatchesColor) === String(slot)) {
          applyLetterColorToInputs(hex, 'Custom: ' + hex);
        }
      });
      /* `change` fires when the picker dialog closes — that's when we
         advance to the next slot (give the customer time to settle). */
      input.addEventListener('change', function () {
        if (useReplaceFlow()) {
          advanceToNextSlot();
        }
      });
    });
  }

  /* "Just like the photo" — fills every slot with its "Keep <name>"
     choice in one tap. */
  function bindUseAsShown() {
    var btn = document.getElementById('ddb-use-as-shown');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var count = parseInt(btn.dataset.colorCount, 10) || 0;
      for (var i = 1; i <= count; i++) {
        var orig = slotOriginal(i);
        if (orig) {
          state.colors[i] = 'Keep ' + orig.name;
        } else {
          /* Cakes that haven't been migrated yet — fall back to the
             legacy "Like Image" so we don't break their flow. */
          state.colors[i] = 'Like Image';
        }
        state.customColorPrices[i] = 0;
        var picker = document.getElementById('ddb-color-picker-' + i);
        if (picker) { picker.classList.remove('is-visible'); picker.setAttribute('aria-hidden', 'true'); }
        if (useReplaceFlow()) renderReplaceSlot(i);
      }
      /* Clear all swatch selections in the palette. */
      document.querySelectorAll('#ddb-step-color .ddb-swatch').forEach(function (s) {
        s.classList.remove('is-selected');
        s.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-active');

      /* Letter input tint — italic "Like Image" hint since no specific hex. */
      if (cfg.letterColorMatchesColor) {
        applyLetterColorToInputs('', 'Like Image');
      }

      if (useReplaceFlow()) {
        /* Refresh keep-swatch (now selected since active slot is now Keep). */
        refreshKeepSwatch();
      }
      updatePrice();
      setTimeout(function () {
        if (validateStep()) goStep(state.step + 1);
      }, 250);
    });
  }

  /* ────────── Photo upload + lock flow ──────────
     v2 — adds the "Looks perfect — lock it" confirmation. The cropper
     was too sensitive: pinch + scroll-wheel zoom and the always-live
     drag meant the photo kept moving AFTER the customer positioned it
     (especially on mobile, where scrolling past the image pans it).
     Fixes:
       1. zoomOnTouch/zoomOnWheel OFF — zoom is the + / − buttons only
       2. Lock button disables the cropper, snapshots the crop data,
          and shows the exact circular result that prints on the cake
       3. validateStep gates Next on state.photoLocked
       4. New uploads reset the lock; fallback paths auto-lock so the
          gate never strands a customer. */
  function bindPhotoUpload() {
    var input = document.getElementById('ddb-photo-upload');
    if (!input) return;

    /* ── Guaranteed photo capture ──────────────────────────────────
       The instant a file is picked we upload the raw image to
       Cloudinary in the background. If Cropper loads and the customer
       positions their photo, the cropped version overwrites this at
       add-to-cart. If Cropper never loads (the bug this fixes), this
       raw upload is what saves the order — the bakery gets the real
       photo instead of "Uploaded (awaiting email)". Status shown to
       the customer is honest: "uploaded" only appears once Cloudinary
       has actually returned a URL. */
    function setPhotoStatus(kind) {
      var host = document.getElementById('ddb-photo-ustat');
      if (!host) {
        host = document.createElement('div');
        host.id = 'ddb-photo-ustat';
        host.setAttribute('role', 'status');
        host.setAttribute('aria-live', 'polite');
        host.style.cssText = 'margin-top:8px;font-size:13px;font-weight:600;text-align:center;line-height:1.45;';
        var anchor = document.getElementById('ddb-photo-file-name') || input;
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(host, anchor.nextSibling);
      }
      if (kind === 'uploading') { host.style.color = '#7a5791'; host.textContent = '\u23F3 Uploading your photo\u2026'; }
      else if (kind === 'done') { host.style.color = '#0a6b2e'; host.textContent = '\u2705 Photo uploaded \u2014 you\u2019re all set.'; }
      else if (kind === 'failed') { host.style.color = '#b91c1c'; host.textContent = '\u26A0\uFE0F Upload didn\u2019t go through \u2014 please check your connection and pick your photo again.'; }
      else { host.textContent = ''; }
    }
    function uploadRawPhoto(file) {
      var myToken = (state.__photoRawToken = (state.__photoRawToken || 0) + 1);
      setPhotoStatus('uploading');
      state.photoRawPromise = new Promise(function (resolve) {
        var attempt = 0;
        (function go() {
          attempt++;
          var form = new FormData();
          form.append('file', file);
          form.append('upload_preset', CLOUDINARY_PRESET);
          fetch(CLOUDINARY_URL, { method: 'POST', body: form })
            .then(function (r) { if (!r.ok) throw new Error('Cloudinary HTTP ' + r.status); return r.json(); })
            .then(function (data) {
              if (myToken !== state.__photoRawToken) return resolve(null);
              if (!data || !data.secure_url) throw new Error('No URL returned');
              if (!state.photoUrl) {
                state.photoUrl       = data.secure_url;
                state.photoUrlWidth  = data.width  || 0;
                state.photoUrlHeight = data.height || 0;
              }
              setPhotoStatus('done');
              resolve(data);
            })
            .catch(function (err) {
              if (myToken !== state.__photoRawToken) return resolve(null);
              if (attempt < 3) { setTimeout(go, 1500); return; }
              setPhotoStatus('failed');
              dwarn('[ddb] raw photo upload failed:', err && err.message);
              resolve(null);
            });
        })();
      });
      return state.photoRawPromise;
    }

    var preview     = document.getElementById('ddb-photo-preview');
    var imgEl       = document.getElementById('ddb-photo-cropper-img');
    var changeBtn   = document.getElementById('ddb-photo-preview-change');
    var zoomInBtn   = document.getElementById('ddb-photo-zoom-in');
    var zoomOutBtn  = document.getElementById('ddb-photo-zoom-out');
    var resetBtn    = document.getElementById('ddb-photo-reset');
    var lockBtn     = document.getElementById('ddb-photo-lock');
    var lockNote    = document.getElementById('ddb-photo-lock-note');
    var lockedBadge = document.getElementById('ddb-photo-locked-badge');
    var lockedThumb = document.getElementById('ddb-photo-locked-thumb');
    var lockedImg   = document.getElementById('ddb-photo-locked-img');
    var cropperWrap = document.getElementById('ddb-photo-cropper-wrap');
    var zoomCtrls   = document.getElementById('ddb-photo-zoom-controls');
    var hintEl      = document.getElementById('ddb-photo-hint');
    var labelEl     = document.getElementById('ddb-photo-preview-label');

    function getCropper() { return state.cropperInstance || null; }
    function setCropper(c) { state.cropperInstance = c; }

    /* Toggle every UI piece between editing and locked states. Kept in
       one place so lock, unlock, and re-upload all stay consistent. */
    function setLockedUI(locked) {
      if (lockedBadge) lockedBadge.style.display = locked ? 'flex' : 'none';
      if (lockedThumb) lockedThumb.style.display = locked ? 'block' : 'none';
      if (cropperWrap) cropperWrap.style.display = locked ? 'none' : '';
      if (zoomCtrls) {
        zoomCtrls.style.opacity = locked ? '0.35' : '';
        zoomCtrls.style.pointerEvents = locked ? 'none' : '';
        zoomCtrls.style.display = locked ? 'none' : 'flex';
      }
      if (hintEl)   hintEl.style.display   = locked ? 'none' : '';
      if (labelEl)  labelEl.style.display  = locked ? 'none' : '';
      if (lockNote) lockNote.style.display = locked ? 'none' : '';
      if (lockBtn) {
        if (locked) {
          lockBtn.textContent = 'Adjust photo';
          lockBtn.style.background = '#fff';
          lockBtn.style.color = '#4a2a60';
          lockBtn.style.border = '1.5px solid rgba(0,0,0,0.18)';
          lockBtn.style.fontWeight = '600';
        } else {
          lockBtn.textContent = '✓ Looks perfect — lock it';
          lockBtn.style.background = '#4a2a60';
          lockBtn.style.color = '#fff';
          lockBtn.style.border = 'none';
          lockBtn.style.fontWeight = '700';
        }
      }
    }

    function lockPhoto() {
      var c = getCropper();
      if (!c) {
        /* Fallback path — Cropper never loaded, nothing draggable to
           freeze. Mark locked so validation doesn't strand the customer. */
        state.photoLocked = true;
        setLockedUI(true);
        if (lockedThumb) lockedThumb.style.display = 'none';
        if (cropperWrap) cropperWrap.style.display = '';
        updateSummary();
        return;
      }
      /* Snapshot the crop data NOW — this is the customer-approved
         position, immune to anything that happens after. */
      try {
        var d = c.getData();
        state.photoCropData = {
          x:      Math.round(d.x),
          y:      Math.round(d.y),
          width:  Math.round(d.width),
          height: Math.round(d.height)
        };
      } catch (e) { dwarn('[ddb] getData on lock threw:', e); }
      /* Render the exact circular result that prints on the sugar
         paper — strongest possible "yes, this is right" confirmation. */
      try {
        var canvas = c.getCroppedCanvas({
          maxWidth: 600, maxHeight: 600,
          imageSmoothingEnabled: true, imageSmoothingQuality: 'high'
        });
        if (canvas && lockedImg) lockedImg.src = canvas.toDataURL('image/png');
      } catch (e) {
        dwarn('[ddb] getCroppedCanvas on lock threw:', e);
        /* Couldn't render the result — keep the (disabled) cropper
           visible instead so the customer still sees their photo. */
        if (lockedThumb) lockedThumb.style.display = 'none';
      }
      try { c.disable(); } catch (e) {}
      state.photoLocked = true;
      setLockedUI(true);
      /* If the thumb render failed above, re-show the frozen cropper. */
      if (lockedImg && !lockedImg.src) {
        if (lockedThumb) lockedThumb.style.display = 'none';
        if (cropperWrap) cropperWrap.style.display = '';
      }
      updateSummary();
    }

    function unlockPhoto() {
      state.photoLocked = false;
      var c = getCropper();
      if (c) { try { c.enable(); } catch (e) {} }
      setLockedUI(false);
      updateSummary();
    }

    if (lockBtn) lockBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (state.photoLocked) unlockPhoto();
      else lockPhoto();
    });

    if (changeBtn) changeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      input.click();
    });

    /* Zoom + reset — while locked these no-op anyway (Cropper ignores
       zoom/reset when disabled) and the controls are hidden, but the
       guards stay for safety. */
    if (zoomInBtn) zoomInBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var c = getCropper();
      if (c && c.zoom && !state.photoLocked) c.zoom(0.1);
    });
    if (zoomOutBtn) zoomOutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var c = getCropper();
      if (c && c.zoom && !state.photoLocked) c.zoom(-0.1);
    });
    if (resetBtn) resetBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var c = getCropper();
      if (c && c.reset && !state.photoLocked) c.reset();
    });

    function waitForCropper(cb) {
      if (typeof window.Cropper !== 'undefined') return cb(true);
      var tries = 0;
      var iv = setInterval(function () {
        if (typeof window.Cropper !== 'undefined') {
          clearInterval(iv); cb(true);
        } else if (++tries > 50) {
          clearInterval(iv); cb(false);
        }
      }, 100);
    }

    function applyFallbackStyling() {
      imgEl.style.width = '260px';
      imgEl.style.height = '260px';
      imgEl.style.maxWidth = '72vw';
      imgEl.style.maxHeight = '72vw';
      imgEl.style.objectFit = 'cover';
      imgEl.style.borderRadius = '50%';
      imgEl.style.border = '8px solid #f8f2ea';
      imgEl.style.boxShadow = '0 8px 24px rgba(26,23,20,0.15)';
      imgEl.style.display = 'block';
      imgEl.style.margin = '0 auto';
    }

    input.addEventListener('change', function () {
      var file   = this.files[0];
      var wrap   = document.getElementById('ddb-photo-wrap');
      var nameEl = document.getElementById('ddb-photo-file-name');

      /* Any new file selection (or clearing) resets the lock — the
         customer must re-confirm the new photo's position. */
      state.photoLocked = false;
      setLockedUI(false);

      if (!file) {
        state.photoUploaded = false;
        state.__photoRawToken = (state.__photoRawToken || 0) + 1;
        state.photoRawPromise = null;
        setPhotoStatus('');
        state.photoDataUrl = '';
        if (wrap)   wrap.classList.remove('has-file');
        if (nameEl) nameEl.textContent = '';
        if (preview) { preview.style.display = 'none'; preview.setAttribute('aria-hidden', 'true'); }
        var existing = getCropper();
        if (existing) { try { existing.destroy(); } catch(e){} setCropper(null); }
        state.photoFile = null;
        return;
      }

      state.photoUploaded = true;
      state.photoFile = file;
      uploadRawPhoto(file); /* guaranteed capture — cropped version overwrites later if Cropper loads */
      /* Reset any prior data URL — will be repopulated when FileReader
         finishes below. Until then, the summary thumb shouldn't show
         a stale image from a previous upload. */
      state.photoDataUrl = '';
      if (wrap)   wrap.classList.add('has-file');
      if (nameEl) nameEl.textContent = '✓ ' + file.name;

      if (!preview || !imgEl || file.type.indexOf('image/') !== 0) {
        /* Non-previewable file — there's nothing to position or lock,
           so auto-lock to keep the Next gate from stranding them. */
        state.photoLocked = true;
        return;
      }

      var reader = new FileReader();
      reader.onload = function (ev) {
        /* Store the data URL on state so the review summary thumb can
           render the customer's actual uploaded image (not just a "✓
           Uploaded" text). */
        state.photoDataUrl = ev.target.result;
        preview.style.display = 'block';
        preview.setAttribute('aria-hidden', 'false');

        var prior = getCropper();
        if (prior) { try { prior.destroy(); } catch(e){} setCropper(null); }

        imgEl.onload = function () {
          waitForCropper(function (available) {
            if (!available) {
              applyFallbackStyling();
              /* No cropper = nothing draggable. Auto-lock so the
                 customer can continue. */
              state.photoLocked = true;
              setLockedUI(true);
              if (lockedThumb) lockedThumb.style.display = 'none';
              if (cropperWrap) cropperWrap.style.display = '';
              return;
            }
            try {
              var c = new window.Cropper(imgEl, {
                aspectRatio: 1,
                viewMode: 3,
                dragMode: 'move',
                autoCropArea: 1,
                guides: false,
                center: true,
                highlight: false,
                cropBoxMovable: false,
                cropBoxResizable: false,
                toggleDragModeOnDblclick: false,
                background: false,
                modal: false,
                movable: true,
                zoomable: true,
                /* Sensitivity fix — pinch + scroll-wheel zoom are OFF.
                   Customers were accidentally moving the photo when
                   scrolling past it. Zoom is the + / − buttons only. */
                zoomOnTouch: false,
                zoomOnWheel: false,
                wheelZoomRatio: 0.1,
                minCropBoxWidth: 200,
                minCropBoxHeight: 200,
                ready: function () {
                  state.photoCropReady = true;
                },
                crop: function (event) {
                  /* While locked, the cropper is disabled and can't
                     fire — but guard anyway so the approved snapshot
                     can never be overwritten. */
                  if (state.photoLocked) return;
                  state.photoCropData = {
                    x:      Math.round(event.detail.x),
                    y:      Math.round(event.detail.y),
                    width:  Math.round(event.detail.width),
                    height: Math.round(event.detail.height)
                  };
                }
              });
              setCropper(c);
            } catch (err) {
              dwarn('[ddb] Cropper init threw:', err);
              applyFallbackStyling();
              state.photoLocked = true;
              setLockedUI(true);
              if (lockedThumb) lockedThumb.style.display = 'none';
              if (cropperWrap) cropperWrap.style.display = '';
            }
          });
        };
        imgEl.onerror = function () {
          dwarn('[ddb] image failed to load into preview');
        };
        imgEl.src = ev.target.result;
      };
      reader.onerror = function () {
        dwarn('[ddb] FileReader failed.');
      };
      reader.readAsDataURL(file);
    });
  }

  function bindBgColorSwatches() {
    document.querySelectorAll('[data-bg-color]').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('[data-bg-color]').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.bgColor = this.dataset.bgColor;
      });
      swatch.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function bindPipingToggle() {
    var toggle = document.getElementById('ddb-piping-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var panel = document.getElementById('ddb-piping-panel');
      var isOpen = toggle.classList.contains('is-selected');
      toggle.classList.toggle('is-selected', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (panel) {
        panel.classList.toggle('ddb-hidden', isOpen);
        panel.setAttribute('aria-hidden', String(isOpen));
      }
      state.piping.enabled = !isOpen;
      if (isOpen) state.piping.color = '';
      updatePrice();
    });
  }

  function bindPipingSwatches() {
    document.querySelectorAll('.ddb-piping-swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('.ddb-piping-swatch').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.piping.color = this.dataset.pipingColor;
      });
      sw.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function bindSprinkleCards() {
    document.querySelectorAll('.ddb-sprinkle-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('.ddb-sprinkle-card').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.sprinkle.key   = this.dataset.sprinkleKey;
        state.sprinkle.name  = this.dataset.sprinkleName;
        state.sprinkle.price = parseInt(this.dataset.sprinklePrice, 10) / 100;
        updatePrice();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function bindNakedCards() {
    document.querySelectorAll('.ddb-naked-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('.ddb-naked-card').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.nakedChoice = this.dataset.naked;

        var prevId = currentStepId();
        buildSteps();
        var newIdx = state.steps.indexOf(prevId);
        if (newIdx < 0) newIdx = Math.max(0, state.steps.indexOf('size'));
        state.step = newIdx;

        filterFlavorsByNaked();
        if (state.nakedChoice === 'naked' && state.flavor) {
          var item = document.querySelector('.ddb-flavor-item[data-flavor="' + state.flavor + '"]');
          if (item && item.dataset.nakedOk !== 'true') {
            state.flavor = '';
            state.flavorPrice = 0;
            document.querySelectorAll('.ddb-flavor-item').forEach(function (i) {
              i.classList.remove('is-selected');
              i.setAttribute('aria-selected', 'false');
            });
          }
        }
        updateNav();
        updatePrice();
        /* Auto-advance to the next step — the customer's made a binary
           pick (naked vs frosted) and shouldn't have to tap Next. We
           defer briefly so the selected state is visible before the
           transition. validateStep guards in case rebuildSteps moved
           things around (it shouldn't, but defensive). */
        setTimeout(function () {
          if (validateStep()) goStep(state.step + 1);
        }, 250);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function filterFlavorsByNaked() {
    refreshFlavorVisibility();
  }

  function bindBowColorSwatches() {
    document.querySelectorAll('.ddb-bow-swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('.ddb-bow-swatch').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.bowColor = this.dataset.bowColor;
      });
      sw.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function bindFlowerColorSwatches() {
    document.querySelectorAll('.ddb-flower-swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('.ddb-flower-swatch').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.flowerColor = this.dataset.flowerColor;
      });
      sw.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  /* Gender Reveal step — Pink / Blue / "I'll send the letter".
     Three cards (Pink + Blue side-by-side, Letter as full-width below).
     When "Letter" is picked, an orange instructions box becomes visible
     explaining where to email the sealed envelope. */
  function bindGenderCards() {
    var cards = document.querySelectorAll('.ddb-gender-card');
    var instructions = document.querySelector('.ddb-gender-letter-instructions');
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        cards.forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.gender = this.dataset.genderValue || '';
        /* Show / emphasize the email instructions when "Letter" picked. */
        if (instructions) {
          if (state.gender === 'Letter') {
            instructions.hidden = false;
          } else {
            instructions.hidden = true;
          }
        }
        /* Mirror onto window.ddbState so the flavor whitelist injector
           (which is a separate IIFE) can read it. Also dispatch a custom
           event the injector listens for to re-apply the whitelist. */
        if (!window.ddbState) window.ddbState = {};
        window.ddbState.gender = state.gender;
        try { document.dispatchEvent(new CustomEvent('ddb:gender-changed', { detail: { gender: state.gender }})); }
        catch (_e) {}
        /* If the customer changed their previous flavor pick and the new
           gender restricts the list, clear the now-invalid flavor. */
        var allowed = ['Vanilla','Vanilla Dulce de Leche','▪️Tres Leches Passion Fruit','✨ Lemon','✨ Coconut'];
        var restrict = state.gender === 'Pink' || state.gender === 'Blue' || state.gender === 'Letter';
        if (restrict && state.flavor && allowed.indexOf(state.flavor) === -1) {
          state.flavor = '';
        }
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  /* Pearl decoration step (cakes flagged with cake_has_pearls).
     Same selection pattern as flower color but auto-advances on
     pick — the customer's made a single decisive choice and shouldn't
     have to tap Next. */
  function bindPearlSwatches() {
    document.querySelectorAll('.ddb-pearl-swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('.ddb-pearl-swatch').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.pearlChoice = this.dataset.pearlColor;
        setTimeout(function () {
          if (validateStep()) goStep(state.step + 1);
        }, 250);
      });
      sw.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function bindAccentSwatches() {
    document.querySelectorAll('.ddb-accent-swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var group = sw.dataset.accentGroup;
        var slot  = sw.dataset.accentSlot;
        document.querySelectorAll('.ddb-accent-swatch[data-accent-group="' + group + '"][data-accent-slot="' + slot + '"]').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        var target = group === '1' ? state.accent1 : state.accent2;
        target[slot] = sw.dataset.accentValue;
      });
      sw.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function bindLetterStyles() {
    document.querySelectorAll('.ddb-text-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (this.classList.contains('is-unavailable')) return;
        document.querySelectorAll('.ddb-text-card').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.letterStyle = this.dataset.style;

        if (state.letterStyle === 'none') {
          state.msgLines = { l1: '', l2: '', l3: '' };
          state.msgFreeform = '';
          state.message = '';
          state.letterColor = '';
          state.letterColorCustomHex = '';
          state.letterColorCustomFee = 0;
          ['groovy','fondant'].forEach(function (s) {
            [1,2,3].forEach(function (n) {
              var inp = document.getElementById('ddb-' + s + '-line' + n);
              if (inp) inp.value = '';
            });
          });
          ['cursive','block'].forEach(function (s) {
            var inp = document.getElementById('ddb-' + s + '-text');
            if (inp) inp.value = '';
          });
          var fields = document.getElementById('ddb-msg-style-fields');
          if (fields) fields.classList.add('ddb-hidden');
          var lcWrap = document.getElementById('ddb-letter-color-wrap');
          if (lcWrap) lcWrap.classList.add('ddb-hidden');
          document.querySelectorAll('.ddb-letter-swatch').forEach(function (s) {
            s.classList.remove('is-selected');
            s.setAttribute('aria-checked', 'false');
          });
          var pw = document.getElementById('ddb-letter-color-picker-wrap');
          if (pw) { pw.classList.remove('is-visible'); pw.setAttribute('aria-hidden', 'true'); }
          updatePrice();
          if (currentStepId() === 'message') setTimeout(function () {
            if (validateStep()) goStep(state.step + 1);
          }, 220);
          return;
        }

        if (state.letterStyle === 'groovy') {
          state.letterColor = '';
          state.letterColorCustomHex = '';
          state.letterColorCustomFee = 0;
          document.querySelectorAll('.ddb-letter-swatch').forEach(function (s) {
            s.classList.remove('is-selected');
            s.setAttribute('aria-checked', 'false');
          });
          var pw = document.getElementById('ddb-letter-color-picker-wrap');
          if (pw) {
            pw.classList.remove('is-visible');
            pw.setAttribute('aria-hidden', 'true');
          }
        }

        showStylePanel(state.letterStyle);
        var fields = document.getElementById('ddb-msg-style-fields');
        if (fields) fields.classList.remove('ddb-hidden');
        var lcWrap = document.getElementById('ddb-letter-color-wrap');
        if (lcWrap) lcWrap.classList.toggle('ddb-hidden', state.letterStyle === 'groovy');
        applyCharLimits();
        refreshLetterColorOnInputs();
        updatePrice();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function showStylePanel(style) {
    ['groovy','fondant','cursive','block'].forEach(function (s) {
      var p = document.getElementById('ddb-style-panel-' + s);
      if (p) p.classList.toggle('ddb-hidden', s !== style);
    });
  }

  function refreshLetterStyleAvailability() {
    var sk = sizeKeyFor(state.sizeName);
    var warn = document.getElementById('ddb-tier-warning');
    var isTier = (sk === 'tier');
    if (warn) warn.classList.toggle('ddb-hidden', !isTier);
    document.querySelectorAll('.ddb-text-card').forEach(function (card) {
      var style = card.dataset.style;
      var disabled = isTier && (style === 'groovy' || style === 'fondant');
      card.classList.toggle('is-unavailable', disabled);
      if (disabled) {
        card.setAttribute('aria-disabled', 'true');
        if (card.classList.contains('is-selected')) {
          card.classList.remove('is-selected');
          card.setAttribute('aria-checked', 'false');
          state.letterStyle = '';
          var fields = document.getElementById('ddb-msg-style-fields');
          if (fields) fields.classList.add('ddb-hidden');
        }
      } else {
        card.removeAttribute('aria-disabled');
      }
    });
  }

  function applyCharLimits() {
    var style = state.letterStyle;
    if (!style || !CHAR_LIMITS[style]) return;
    var sk = sizeKeyFor(state.sizeName);
    if (sk === 'tier') sk = 'large';
    var limits = CHAR_LIMITS[style][sk] || CHAR_LIMITS[style].medium;
    [1,2,3].forEach(function (n) {
      var input = document.getElementById('ddb-' + style + '-line' + n);
      var max   = document.getElementById('ddb-' + style + '-l' + n + 'max');
      var hasLimit = limits[n-1] !== undefined;
      if (input) {
        if (hasLimit) {
          input.maxLength = limits[n-1];
          if (input.parentNode) input.parentNode.style.display = '';
        } else {
          input.value = '';
          if (input.parentNode) input.parentNode.style.display = 'none';
          var lbl = document.querySelector('label[for="ddb-' + style + '-line' + n + '"]');
          if (lbl) lbl.style.display = 'none';
        }
      }
      if (max && hasLimit) { max.textContent = limits[n-1]; }
    });
    var note = document.getElementById('ddb-' + style + '-note');
    if (note) {
      var sl = CHAR_LIMITS[style];
      if (cfg.isMini && sl.mini) {
        note.textContent = 'Bento: ' + sl.mini.join('/');
      } else {
        note.textContent = 'Fun Size: ' + sl.fun.join('/') + ' · Medium: ' + sl.medium.join('/') + ' · Large: ' + sl.large.join('/');
      }
    }
  }

  function bindLetterColors() {
    document.querySelectorAll('.ddb-letter-swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        document.querySelectorAll('.ddb-letter-swatch').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.letterColor = this.dataset.letter;
        state.letterColorCustomFee = (state.letterColor === 'Custom') ? 5 : 0;
        var pw = document.getElementById('ddb-letter-color-picker-wrap');
        if (pw) {
          var isCustom = state.letterColor === 'Custom';
          pw.classList.toggle('is-visible', isCustom);
          pw.setAttribute('aria-hidden', String(!isCustom));
          if (!isCustom) state.letterColorCustomHex = '';
          if (isCustom && !state.letterColorCustomHex) {
            var picker = document.getElementById('ddb-letter-color-picker');
            if (picker) state.letterColorCustomHex = picker.value;
          }
        }
        if (state.letterColor === 'Custom') {
          applyLetterColorToInputs(state.letterColorCustomHex || '', 'Custom');
        } else {
          applyLetterColorToInputs(this.dataset.letterHex || '', state.letterColor);
        }
        updatePrice();
      });
      sw.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function applyLetterColorToInputs(hex, label) {
    var inputs = document.querySelectorAll('.ddb-msg-input');
    if (!inputs.length) return;
    var color = hex || '';
    var isLikeImage = (label === 'Like Image');
    inputs.forEach(function (inp) {
      inp.style.color = (color && !isLikeImage) ? color : '';
      inp.style.fontStyle = isLikeImage ? 'italic' : '';
    });
  }

  function refreshLetterColorOnInputs() {
    if (!cfg.hasLetterColors) return;
    var sel = document.querySelector('.ddb-letter-swatch.is-selected');
    if (!sel) {
      applyLetterColorToInputs('', '');
      return;
    }
    var label = sel.dataset.letter;
    if (label === 'Custom') {
      applyLetterColorToInputs(state.letterColorCustomHex || '#c39bde', 'Custom');
    } else {
      applyLetterColorToInputs(sel.dataset.letterHex || '', label);
    }
  }

  function bindLetterColorPicker() {
    var picker = document.getElementById('ddb-letter-color-picker');
    if (!picker) return;
    picker.addEventListener('input', function () {
      state.letterColorCustomHex = this.value;
      var prev = document.getElementById('ddb-letter-color-preview');
      var hex  = document.getElementById('ddb-letter-color-hex');
      if (prev) prev.style.background = this.value;
      if (hex)  hex.textContent = this.value;
      applyLetterColorToInputs(this.value, 'Custom');
    });
  }

  function bindMessageInput() {
    ['groovy','fondant'].forEach(function (style) {
      [1,2,3].forEach(function (n) {
        var input = document.getElementById('ddb-' + style + '-line' + n);
        if (!input) return;
        input.addEventListener('input', function () {
          state.msgLines['l' + n] = this.value;
          var cnt = document.getElementById('ddb-' + style + '-l' + n + 'c');
          if (cnt) cnt.textContent = this.value.length;
        });
      });
    });
    ['cursive','block'].forEach(function (style) {
      var input = document.getElementById('ddb-' + style + '-input');
      if (!input) return;
      if (cfg.isMini) {
        input.setAttribute('maxlength', String(MINI_CURSIVE_BLOCK_MAX));
        var initCount = document.getElementById('ddb-' + style + '-count');
        var maxLabel  = input.parentNode && input.parentNode.querySelector('.ddb-char-count');
        if (maxLabel) {
          maxLabel.innerHTML = '<span id="ddb-' + style + '-count">' + (initCount ? initCount.textContent : '0') + '</span>/' + MINI_CURSIVE_BLOCK_MAX;
        }
      }
      input.addEventListener('input', function () {
        state.msgFreeform = this.value;
        var cnt = document.getElementById('ddb-' + style + '-count');
        if (cnt) cnt.textContent = this.value.length;
      });
    });

    var simple = document.getElementById('ddb-msg-text');
    if (simple) {
      if (cfg.messageDefault && !simple.value) {
        simple.value = cfg.messageDefault;
        state.message = cfg.messageDefault;
        var initCnt = document.getElementById('ddb-msg-char-count');
        if (initCnt) initCnt.textContent = cfg.messageDefault.length;
      } else if (simple.value) {
        state.message = simple.value;
      }
      simple.addEventListener('input', function () {
        state.message = this.value;
        var cnt = document.getElementById('ddb-msg-char-count');
        if (cnt) cnt.textContent = this.value.length;
      });
    }

    var extra = document.getElementById('ddb-extra-msg');
    if (extra) {
      if (cfg.extraMessageDefault && !extra.value) {
        extra.value = cfg.extraMessageDefault;
      }
      state.extraMessage = extra.value || '';
      extra.addEventListener('input', function () {
        state.extraMessage = this.value;
        var cnt = document.getElementById('ddb-extra-msg-count');
        if (cnt) cnt.textContent = this.value.length;
      });
    }

    var numInput = document.getElementById('ddb-cake-number');
    if (numInput) {
      numInput.addEventListener('input', function () {
        var maxDigits = cfg.numberMaxDigits || 2;
        if (this.value.length > maxDigits) {
          this.value = this.value.slice(0, maxDigits);
        }
        state.cakeNumber = this.value;
      });
    }
  }

  function bindSkipMessage() {
    var btn = document.getElementById('ddb-skip-message');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      state.message = '';
      state.msgLines = { l1: '', l2: '', l3: '' };
      state.msgFreeform = '';
      state.letterStyle = '';
      goStep(state.step + 1);
    });
  }

  function bindSumEditBtns() {
    document.querySelectorAll('.ddb-sum-edit').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var targetStep = this.dataset.step;
        var idx = state.steps.indexOf(targetStep);
        if (idx >= 0) goStep(idx);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function bindAddonRows() {
    ['candles', 'gift'].forEach(function (id) {
      var row   = document.getElementById('ddb-addon-row-' + id);
      var card  = document.getElementById('ddb-addon-card-' + id);
      var panel = document.getElementById('ddb-sub-panel-' + id);
      if (!row) return;
      row.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var isOpen = card && card.classList.contains('is-selected');
        if (card)  card.classList.toggle('is-selected', !isOpen);
        if (panel) { panel.classList.toggle('is-open', !isOpen); panel.setAttribute('aria-hidden', String(isOpen)); }
        row.setAttribute('aria-expanded', String(!isOpen));
        if (id === 'candles') {
          state.candles.selected = !isOpen;
          if (isOpen) {
            state.candles.types.rainbow.active   = false;
            state.candles.types.sparklers.active = false;
            state.candles.types.metallic.active  = false;
            state.candles.types.metallic.color   = '';
            state.candles.types.number.active    = false;
            state.candles.types.number.color     = '';
            state.candles.types.number.number    = '';
            document.querySelectorAll('.ddb-type-pill').forEach(function (p) {
              p.classList.remove('is-selected');
              p.setAttribute('aria-checked', 'false');
            });
            ['rainbow','sparklers','metallic','number'].forEach(function (t) {
              var el = document.getElementById('ddb-candle-sub-' + t);
              if (el) el.style.display = 'none';
            });
            var cn = document.getElementById('ddb-candle-number');
            if (cn) cn.value = '';
            document.querySelectorAll('[data-tile-group="candle-color"]').forEach(function (t) {
              t.classList.remove('is-selected');
              t.setAttribute('aria-checked', 'false');
            });
          }
        }
        if (id === 'gift') {
          state.gift.selected = !isOpen;
          if (isOpen) {
            state.gift.text = '';
            var gt = document.getElementById('ddb-gift-text');
            if (gt) gt.value = '';
          }
        }
        updatePrice();
      });
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function bindCandleTypes() {
    document.querySelectorAll('.ddb-type-pill').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var type = this.dataset.type;
        var typeState = state.candles.types[type];
        if (!typeState) return;
        typeState.active = !typeState.active;
        this.classList.toggle('is-selected', typeState.active);
        this.setAttribute('aria-checked', typeState.active ? 'true' : 'false');
        var sub = document.getElementById('ddb-candle-sub-' + type);
        if (sub) sub.style.display = typeState.active ? 'block' : 'none';
        if (!typeState.active) {
          if (type === 'metallic') typeState.color = '';
          if (type === 'number')   { typeState.color = ''; typeState.number = ''; }
          document.querySelectorAll('[data-tile-group="candle-color-' + type + '"]').forEach(function (t) {
            t.classList.remove('is-selected');
            t.setAttribute('aria-checked', 'false');
          });
          if (type === 'number') {
            var cn = document.getElementById('ddb-candle-number');
            if (cn) cn.value = '';
          }
        }
        updatePrice();
      });
      pill.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function bindImageTiles() {
    document.querySelectorAll('.ddb-img-tile').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var group = this.dataset.tileGroup;
        if (!group) return;
        document.querySelectorAll('[data-tile-group="' + group + '"]').forEach(function (t) {
          t.classList.remove('is-selected');
          t.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        if (group === 'candle-color-metallic') {
          state.candles.types.metallic.color = this.dataset.tileValue;
          updatePrice();
        } else if (group === 'candle-color-number') {
          state.candles.types.number.color = this.dataset.tileValue;
          updatePrice();
        }
      });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });

    var candleNumInput = document.getElementById('ddb-candle-number');
    if (candleNumInput) {
      candleNumInput.addEventListener('input', function () {
        var cleaned = String(this.value).replace(/\D/g, '').slice(0, 2);
        if (cleaned !== this.value) this.value = cleaned;
        state.candles.types.number.number = cleaned;
        updatePrice();
      });
    }
  }

  function bindExtraCards() {
    document.querySelectorAll('.ddb-extra-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = this.id.replace('ddb-extra-', '');
        if (!state.extras[id]) return;
        state.extras[id].selected = !state.extras[id].selected;
        this.classList.toggle('is-selected', state.extras[id].selected);
        this.setAttribute('aria-checked', String(state.extras[id].selected));
        updatePrice();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'ddb-gift-text') {
      state.gift.text = e.target.value;
    }
  });

  function showStepError(stepId, msg) {
    var errId = stepId + '-err';
    var err = document.getElementById(errId);
    if (!err) {
      err = document.createElement('div');
      err.id = errId;
      err.style.cssText = 'color:#b91c1c;font-size:13px;font-weight:600;padding:10px 12px;background:#fff5f5;border:1px solid #e57373;border-radius:8px;margin-top:10px;';
      var step = document.getElementById(stepId);
      if (step) step.appendChild(err);
    }
    err.textContent = msg;
    err.style.display = 'block';
    setTimeout(function () { if (err) err.style.display = 'none'; }, 3000);
  }

  function validateStep() {
    var id = currentStepId();
    var stepEl = 'ddb-step-' + id;
    if (id === 'size' && !state.variantId) {
      showStepError(stepEl, '⚠️ Please choose a size to continue.');
      return false;
    }
    if (id === 'flavor') {
      var requiredSlots = flavorSlotCount();
      if (requiredSlots > 1) {
        /* All slots must be filled before leaving the flavor step. */
        var missing = 0;
        for (var sv = 0; sv < requiredSlots; sv++) {
          if (!state.flavors[sv]) missing++;
        }
        if (missing > 0) {
          var msg = (requiredSlots === 2)
            ? '⚠️ Please pick a flavor for both tiers to continue.'
            : '⚠️ Please pick a flavor for all 4 cakes to continue.';
          showStepError(stepEl, msg);
          return false;
        }
      } else if (!state.flavor) {
        showStepError(stepEl, '⚠️ Please choose a flavor to continue.');
        return false;
      }
    }
    if (id === 'diet' && state.diet.nut && !state.nutAcknowledged) {
      showStepError(stepEl, '⚠️ Please acknowledge the nut allergy notice to continue.');
      return false;
    }
    if (id === 'diet' && state.diet.gf && !state.gfAcknowledged) {
      showStepError(stepEl, '⚠️ Please acknowledge the gluten notice to continue.');
      return false;
    }
    if (id === 'naked' && !state.nakedChoice) {
      showStepError(stepEl, '⚠️ Please choose naked or fully frosted to continue.');
      return false;
    }
    if (id === 'color' && cfg.hasColors) {
      var cc = cfg.colorCount || 1;
      for (var ci = 1; ci <= cc; ci++) {
        if (!state.colors[String(ci)] && !state.colors[ci]) {
          var msg;
          if (useReplaceFlow()) {
            var orig = slotOriginal(ci);
            msg = orig
              ? '⚠️ Please choose what to replace the ' + orig.name.toLowerCase() + ' with (or keep it).'
              : '⚠️ Please pick Color ' + ci + ' to continue.';
          } else {
            msg = '⚠️ Please choose a buttercream color to continue.';
          }
          showStepError(stepEl, msg);
          /* Helpful UX — jump to the first unfilled slot. */
          if (useReplaceFlow()) setActiveReplaceSlot(ci);
          return false;
        }
      }
    }
    if (id === 'bow-color' && !state.bowColor) {
      showStepError(stepEl, '⚠️ Please choose a bow color to continue.');
      return false;
    }
    if (id === 'gender' && !state.gender) {
      showStepError(stepEl, '⚠️ Please pick Pink, Blue, or "I\'ll send the letter" to continue.');
      return false;
    }
    if (id === 'flower-color' && !state.flowerColor) {
      showStepError(stepEl, '⚠️ Please choose a flower color to continue.');
      return false;
    }
    if (id === 'accent1') {
      for (var v1 = 1; v1 <= (cfg.accent1Count || 1); v1++) {
        if (!state.accent1[v1]) {
          showStepError(stepEl, '⚠️ Please choose ' + (cfg.accent1Count > 1 ? 'all colors' : 'a color') + ' for ' + cfg.accent1Label + '.');
          return false;
        }
      }
    }
    if (id === 'accent2') {
      for (var v2 = 1; v2 <= (cfg.accent2Count || 1); v2++) {
        if (!state.accent2[v2]) {
          showStepError(stepEl, '⚠️ Please choose ' + (cfg.accent2Count > 1 ? 'all colors' : 'a color') + ' for ' + cfg.accent2Label + '.');
          return false;
        }
      }
    }
    if (id === 'photo' && cfg.hasPhotoUpload) {
      if (!state.photoUploaded) {
        showStepError(stepEl, '⚠️ Please upload a photo to continue.');
        return false;
      }
      if (!state.photoLocked) {
        showStepError(stepEl, '⚠️ Almost there — tap "✓ Looks perfect — lock it" to confirm your photo.');
        return false;
      }
    }
    if (id === 'number' && !state.cakeNumber) {
      showStepError(stepEl, '⚠️ Please enter a number to continue.');
      return false;
    }
    if (id === 'sprinkles' && !state.sprinkle.key) {
      showStepError(stepEl, '⚠️ Please choose a sprinkle option to continue.');
      return false;
    }
    if (id === 'message' && !cfg.messageOptional) {
      if (cfg.hasLetterStyles) {
        if (!state.letterStyle) { showStepError(stepEl, '⚠️ Please choose a lettering style.'); return false; }
        if (state.letterStyle === 'none') { return true; }
        if (state.letterStyle === 'groovy' || state.letterStyle === 'fondant') {
          if (!state.msgLines.l1.trim()) { showStepError(stepEl, '⚠️ Please enter message line 1.'); return false; }
        } else {
          if (!state.msgFreeform.trim()) { showStepError(stepEl, '⚠️ Please enter your message.'); return false; }
        }
        var letterColorInherited = (cfg.letterColorMatchesColor && cfg.letterColorMatchesColor > 0)
                                || cfg.letterColorMatchesBow;
        if (cfg.hasLetterColors && state.letterStyle !== 'groovy' && !letterColorInherited) {
          if (!state.letterColor) {
            showStepError(stepEl, '⚠️ Please choose a letter color to continue.');
            return false;
          }
        }
      } else if (!state.message.trim()) {
        showStepError(stepEl, '⚠️ Please enter a message, or tap "Skip" if you don\'t want one.');
        return false;
      }
    }
    return true;
  }

  function normalizeTitle(s) {
    if (!s) return '';
    return String(s)
      .replace(/^[^A-Za-z0-9]+/, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  var _normalizedMaps = {};
  function normalizedMap(sourceMap, sourceName) {
    if (!sourceMap) return {};
    if (_normalizedMaps[sourceName]) return _normalizedMaps[sourceName];
    var out = {};
    Object.keys(sourceMap).forEach(function (k) {
      out[normalizeTitle(k)] = sourceMap[k];
      out[k] = sourceMap[k];
    });
    _normalizedMaps[sourceName] = out;
    return out;
  }

  function lookupVariant(sourceMap, sourceName, title) {
    if (!title) return null;
    var map = normalizedMap(sourceMap, sourceName);
    return map[title] || map[normalizeTitle(title)] || null;
  }

  function buildAddonItems(cakeKey) {
    var items = [];
    var tag = cakeKey ? { '_addon_for': cakeKey } : {};
    var OPT = window.ddbOptionVariants || {};
    var FLAV = window.ddbFlavorVariants || {};

    /* Multi-flavor: add a surcharge line item for EACH specialty flavor.
       Single-flavor: original behavior. */
    if (state.flavors && state.flavors.length > 1) {
      for (var fi = 0; fi < state.flavors.length; fi++) {
        var fname = state.flavors[fi];
        var fprice = state.flavorPrices[fi] || 0;
        if (!fname || fprice <= 0) continue;
        var fid = lookupVariant(FLAV, 'flavors', fname);
        if (fid) {
          items.push({ id: fid, quantity: 1, properties: Object.assign({}, tag) });
        } else {
          dwarn('[ddb] Flavor variant not found for:', fname,
            '— available:', Object.keys(FLAV));
        }
      }
    } else if (state.flavorPrice > 0 && state.flavor) {
      var flavorId = lookupVariant(FLAV, 'flavors', state.flavor);
      if (flavorId) {
        items.push({ id: flavorId, quantity: 1, properties: Object.assign({}, tag) });
      } else {
        dwarn('[ddb] Flavor variant not found for:', state.flavor,
          '— available:', Object.keys(FLAV));
      }
    }

    if (state.diet.gf) {
      items.push({ id: VARIANT_IDS.glutenFree, quantity: 1, properties: Object.assign({}, tag) });
    }

    /* Fully frosted upcharge — adds the "Fully Frosted" variant of the
       Heart Cake Custom Options product as its own $10 line item. The
       variant title is matched by name so renaming it in Shopify will
       break this; if the variant isn't found we log a warning but don't
       block the cart-add. */
    if (cfg.hasNakedOption && state.nakedChoice === 'frosted') {
      var frostedId = lookupVariant(OPT, 'options', 'Fully Frosted');
      if (frostedId) {
        items.push({ id: frostedId, quantity: 1, properties: Object.assign({}, tag) });
      } else {
        dwarn('[ddb] "Fully Frosted" variant not found in options product. Available:', Object.keys(OPT));
      }
    }

    if (cfg.hasColors) {
      var customCount = 0;
      Object.keys(state.customColorPrices).forEach(function (k) {
        if (state.customColorPrices[k] > 0) customCount++;
      });
      if (customCount > 0) {
        var ccId = lookupVariant(OPT, 'options', 'Custom color');
        if (ccId) {
          items.push({ id: ccId, quantity: customCount, properties: Object.assign({}, tag) });
        } else {
          dwarn('[ddb] "Custom color" variant not found in options product. Available:', Object.keys(OPT));
        }
      }
    }

    if (state.letterColorCustomFee > 0) {
      var lcId = lookupVariant(OPT, 'options', 'Custom letter color');
      if (lcId) {
        items.push({ id: lcId, quantity: 1, properties: Object.assign({}, tag) });
      } else {
        dwarn('[ddb] "Custom letter color" variant not found');
      }
    }

    if (cfg.hasPipingColor && state.piping.enabled) {
      var pcId = lookupVariant(OPT, 'options', 'Custom piping color');
      if (pcId) {
        items.push({ id: pcId, quantity: 1, properties: Object.assign({}, tag) });
      } else {
        dwarn('[ddb] "Custom piping color" variant not found');
      }
    }

    if (cfg.hasSprinkles && state.sprinkle.price > 0 && state.sprinkle.name) {
      var candidates = [
        'Sprinkles — ' + state.sprinkle.name,
        'Sprinkles - ' + state.sprinkle.name,
        state.sprinkle.name,
        'Sprinkle upgrade'
      ];
      var sprinkleId = null, matchedTitle = null;
      for (var si = 0; si < candidates.length; si++) {
        sprinkleId = lookupVariant(OPT, 'options', candidates[si]);
        if (sprinkleId) { matchedTitle = candidates[si]; break; }
      }
      if (sprinkleId) {
        var qty = matchedTitle === 'Sprinkle upgrade' ? Math.round(state.sprinkle.price) : 1;
        items.push({ id: sprinkleId, quantity: qty, properties: Object.assign({}, tag) });
      } else {
        dwarn('[ddb] Sprinkle variant not found — tried:', candidates,
          '— available:', Object.keys(OPT));
      }
    }

    if (state.candles.selected) {
      var ts = state.candles.types;
      if (ts.rainbow.active) {
        items.push({ id: VARIANT_IDS.rainbowCandles, quantity: 1, properties: Object.assign({}, tag) });
      }
      if (ts.sparklers.active) {
        items.push({ id: VARIANT_IDS.sparklers, quantity: 1, properties: Object.assign({}, tag) });
      }
      if (ts.metallic.active && ts.metallic.color) {
        var metalId = window.ddbMetallicVariants && window.ddbMetallicVariants[ts.metallic.color];
        if (metalId) {
          items.push({ id: String(metalId), quantity: 1, properties: Object.assign({}, tag) });
        } else {
          dwarn('ddb: metallic candle variant not found:', ts.metallic.color);
        }
      }
      if (ts.number.active && ts.number.color && ts.number.number) {
        var numId = window.ddbCandleVariants && window.ddbCandleVariants[ts.number.color];
        if (numId) {
          var ncp = Object.assign({}, tag);
          ncp['Number'] = ts.number.number;
          var digits = String(ts.number.number).replace(/\D/g, '').length || 1;
          items.push({ id: String(numId), quantity: digits, properties: ncp });
        } else {
          dwarn('ddb: number candle variant not found:', ts.number.color);
        }
      }
    }

    if (state.extras.bow.selected)      items.push({ id: VARIANT_IDS.bow,        quantity: 1, properties: Object.assign({}, tag) });
if (state.extras.server.selected)   items.push({ id: VARIANT_IDS.cakeServer, quantity: 1, properties: Object.assign({}, tag) });
if (state.extras.coldpack.selected) items.push({ id: VARIANT_IDS.coldPack,   quantity: 1, properties: Object.assign({}, tag) });

/* Sugar plaque + Happy Birthday topper from the designer add-on block */
var externalAddons = window.__ddbAddonState || {};
Object.keys(externalAddons).forEach(function (key) {
  var addon = externalAddons[key];
  if (!addon || !addon.active || !addon.active()) return;

  var variantId = addon.variantId && addon.variantId();
  if (!variantId) return;

  var addonProps = Object.assign({}, tag);
  if (addon.props) Object.assign(addonProps, addon.props());

  items.push({
    id: variantId,
    quantity: 1,
    properties: addonProps
  });
});

return items;
  }

  /* Format a single color slot's value for cart line item properties.
     - "Keep <name>" → "<name> (kept as shown)"
     - "Custom: #hex" → "Custom #hex (+$10.00)"
     - "Like Image" → "Like image" (legacy single-color flow)
     - other → just the name */
  function formatColorValue(stateVal, slot) {
    if (!stateVal) return 'Like image';
    if (typeof stateVal === 'string' && stateVal.indexOf('Keep ') === 0) {
      var keepName = stateVal.substring(5);
      return keepName + ' (kept as shown)';
    }
    if (typeof stateVal === 'string' && stateVal.indexOf('Custom: ') === 0) {
      return 'Custom ' + stateVal.substring(8) + ' (+$10.00)';
    }
    return stateVal;
  }

  function buildProperties() {
    var props = {};
    /* Multi-flavor: emit one property per slot with the slot's label
       (Bottom tier / Top tier / Cake 1 of 4). Single-flavor: emit the
       single Flavor property as before. */
    var slotCount = flavorSlotCount();
    if (slotCount > 1 && state.flavors && state.flavors.length > 0) {
      for (var s = 0; s < slotCount; s++) {
        var name = state.flavors[s] || '';
        if (!name) continue;
        var p = state.flavorPrices[s] || 0;
        var key;
        if (slotCount === 2) {
          key = s === 0 ? 'Bottom tier flavor' : 'Top tier flavor';
        } else {
          key = 'Cake ' + (s + 1) + ' of 4 flavor';
        }
        props[key] = name + (p > 0 ? ' (+$' + p.toFixed(2) + ')' : '');
      }
    } else {
      props['Flavor'] = state.flavor + (state.flavorPrice > 0 ? ' (+$' + state.flavorPrice.toFixed(2) + ')' : '');
    }

    var dietParts = [];
    if (state.diet.gf)  dietParts.push('Gluten-Free (+$15.00)');
    if (state.diet.nut) dietParts.push('Nut Allergy (acknowledged)');
    if (dietParts.length) props['Dietary'] = dietParts.join(' + ');

    /* Macaron-removal flag — set when the customer has a nut allergy
       on a cake that ships with macarons (macarons contain almonds).
       Cart property so the kitchen sees the flag at fulfillment time.
       The note text comes from cfg.macaronRemovalNote (per-cake in
       Liquid). Falls back to a plain "Removed" if no note is set. */
    if (cfg.cakeHasMacarons && state.diet.nut) {
      var macNote = cfg.macaronRemovalNote || "We'll remove them";
      props['Macarons'] = macNote + ' (nut allergy)';
    }

    var colorCount = cfg.colorCount || 1;
    if (cfg.hasColors) {
      if (colorCount === 1) {
        props['Buttercream color'] = formatColorValue(state.colors['1'] || state.colors[1], 1);
      } else {
        /* Multi-color replace flow — add the photo's original color
           name so the bakers know which one's being replaced. */
        for (var i = 1; i <= colorCount; i++) {
          var orig = slotOriginal(i);
          var val = formatColorValue(state.colors[String(i)] || state.colors[i], i);
          var key = 'Color ' + i;
          if (orig) key = 'Color ' + i + ' (' + orig.name + ' on the photo)';
          props[key] = val;
        }
      }
    }

    if (cfg.hasNakedOption && state.nakedChoice) {
      props['Style'] = state.nakedChoice === 'naked' ? 'Naked (sponge visible)' : 'Fully frosted (+$10.00)';
    }

    if (cfg.hasBowColor && state.bowColor) {
      props['Bow color'] = state.bowColor;
    }

    if (cfg.hasFlowerColor && state.flowerColor) {
      props['Flower color'] = state.flowerColor;
    }

    /* Gender reveal cakes — emit the inside color choice as a cart
       property the kitchen can see at fulfillment. "Letter" gets a
       different, more visible string so the kitchen knows the order is
       on hold until the sealed letter arrives via email. "No reveal"
       tells the kitchen to make the cake without any colored interior. */
    if (window.ddbProduct && window.ddbProduct.showsGenderStep && state.gender) {
      if (state.gender === 'Letter') {
        props['Inside surprise'] = '✉️ Customer will email sealed letter to info@dbakers.us (DO NOT BAKE until letter received)';
      } else if (state.gender === 'No reveal') {
        props['Inside surprise'] = 'No gender colors inside (regular cake)';
      } else {
        props['Inside surprise'] = state.gender;
      }
    }

    /* Pearls — only emit a property when the customer actively picked
       one. We label "None" as "No pearls" for kitchen clarity. */
    if (cfg.cakeHasPearls && state.pearlChoice) {
      props['Pearls'] = state.pearlChoice === 'None' ? 'No pearls' : state.pearlChoice + ' pearls';
    }

    if (cfg.accent1Label) {
      var a1vals = [];
      for (var a1 = 1; a1 <= (cfg.accent1Count || 1); a1++) {
        if (state.accent1[a1]) a1vals.push(state.accent1[a1]);
      }
      if (a1vals.length) props[cfg.accent1Label] = a1vals.join(' + ');
    }

    if (cfg.accent2Label) {
      var a2vals = [];
      for (var a2 = 1; a2 <= (cfg.accent2Count || 1); a2++) {
        if (state.accent2[a2]) a2vals.push(state.accent2[a2]);
      }
      if (a2vals.length) props[cfg.accent2Label] = a2vals.join(' + ');
    }

    if (cfg.hasPhotoUpload && state.photoUploaded) {
      if (state.photoUrl) {
        props['Photo'] = state.photoUrl;
        props['Photo size'] = state.photoUrlWidth + '×' + state.photoUrlHeight + ' px';
      } else {
        props['Photo'] = 'Uploaded (awaiting email)';
        if (state.photoFile && state.photoFile.name) {
          props['Photo filename'] = state.photoFile.name;
        }
      }
      if (state.photoCropData) {
        var c = state.photoCropData;
        props['Photo crop'] =
          'x:' + c.x + ', y:' + c.y + ', ' + c.width + '×' + c.height + ' px';
      }
      if (cfg.hasBackgroundColor && state.bgColor) props['Background color'] = state.bgColor;
    }

    if (state.cakeNumber) {
      var numLabel = cfg.numberLabel || 'Number';
      props[numLabel] = state.cakeNumber;
    }

    if (cfg.extraMessageLabel && state.extraMessage) {
      props[cfg.extraMessageLabel] = state.extraMessage;
    }

    if (cfg.hasPipingColor && state.piping.enabled && state.piping.color) {
      props['Piping color'] = state.piping.color + ' (+$5.00)';
    }

    if (cfg.hasSprinkles && state.sprinkle.name) {
      props['Sprinkles'] = state.sprinkle.name + (state.sprinkle.price > 0 ? ' (+$' + state.sprinkle.price.toFixed(2) + ')' : '');
    }

    if (cfg.hasLetterStyles && state.letterStyle) {
      if (state.letterStyle === 'none') {
        props['Lettering'] = 'No text on cake';
      } else {
        var styleLabel = { groovy: 'Groovy letters', fondant: 'Fondant letters', cursive: 'Buttercream cursive', block: 'Buttercream block' }[state.letterStyle];
        props['Lettering style'] = styleLabel;
        if (state.letterStyle === 'groovy' || state.letterStyle === 'fondant') {
          if (state.msgLines.l1) props['Message line 1'] = state.msgLines.l1;
          if (state.msgLines.l2) props['Message line 2'] = state.msgLines.l2;
          if (state.msgLines.l3) props['Message line 3'] = state.msgLines.l3;
        } else {
          if (state.msgFreeform) props['Message'] = state.msgFreeform;
        }
        if (state.letterStyle !== 'groovy') {
          if (cfg.letterColorMatchesColor && state.colors[cfg.letterColorMatchesColor]) {
            props['Letter color'] = formatColorValue(state.colors[cfg.letterColorMatchesColor], cfg.letterColorMatchesColor)
              + ' (matches Color ' + cfg.letterColorMatchesColor + ')';
          } else if (cfg.letterColorMatchesBow && state.bowColor) {
            props['Letter color'] = state.bowColor + ' (matches bow)';
          } else if (state.letterColor) {
            var lc = state.letterColor;
            if (lc === 'Custom' && state.letterColorCustomHex) lc = 'Custom ' + state.letterColorCustomHex + ' (+$5.00)';
            props['Letter color'] = lc;
          }
        }
      }
    } else if (state.message) {
      props['Message'] = state.message;
    }

    if (state.candles.selected) {
      var ts = state.candles.types;
      var parts = [];
      if (ts.rainbow.active)   parts.push('Rainbow candles');
      if (ts.sparklers.active) parts.push('Sparklers');
      if (ts.metallic.active && ts.metallic.color) parts.push('Metallic candles (' + ts.metallic.color + ')');
      if (ts.number.active && ts.number.color && ts.number.number) {
        parts.push('Number candles (' + ts.number.color + ') — #' + ts.number.number);
      }
      if (parts.length) props['Candles'] = parts.join(' + ');
    }
    if (state.gift.selected && state.gift.text.trim()) props['Gift message'] = state.gift.text;
    if (state.extras.bow.selected)      props['XL Gold Bow']   = 'Yes';
    if (state.extras.server.selected)   props['Cake server']   = 'Yes';
    if (state.extras.coldpack.selected) props['Gel cold pack'] = 'Yes';

/* Visible plaque/topper details on the main cake line */
var externalAddons = window.__ddbAddonState || {};
Object.keys(externalAddons).forEach(function (key) {
  var addon = externalAddons[key];
  if (!addon || !addon.active || !addon.active()) return;

  if (addon.props) {
    var addonProps = addon.props();
    Object.keys(addonProps || {}).forEach(function (propKey) {
      props[propKey] = addonProps[propKey];
    });
  }
});

if (window.ddbCalendar && typeof window.ddbCalendar.getProperties === 'function') {
      Object.assign(props, window.ddbCalendar.getProperties());
    }
    if (window.ddbPolaroids && typeof window.ddbPolaroids.getProperties === 'function') {
      Object.assign(props, window.ddbPolaroids.getProperties());
    }
    return props;
  }

  function promisedTotal() {
    /* Multi-flavor: sum surcharges across all picked slots so 4× specialty
       Flight = 4× surcharge. Single-flavor: state.flavorPrice still works. */
    var flavorTotal = 0;
    if (state.flavorPrices && state.flavorPrices.length > 0) {
      for (var fp = 0; fp < state.flavorPrices.length; fp++) {
        flavorTotal += (state.flavorPrices[fp] || 0);
      }
    } else {
      flavorTotal = state.flavorPrice || 0;
    }
    var t = state.basePrice + flavorTotal;
    if (state.diet.gf) t += 15;
    if (cfg.hasPipingColor && state.piping.enabled) t += 5;
    if (state.sprinkle.price) t += state.sprinkle.price;
    if (state.letterColorCustomFee) t += state.letterColorCustomFee;
    Object.keys(state.customColorPrices).forEach(function (k) {
      if (state.customColorPrices[k] > 0) t += state.customColorPrices[k];
    });
    if (state.candles.selected) {
      var ts = state.candles.types;
      if (ts.rainbow.active   && window.ddbRainbowPrice)  t += window.ddbRainbowPrice  / 100;
      if (ts.sparklers.active && window.ddbSparklerPrice) t += window.ddbSparklerPrice / 100;
      if (ts.metallic.active && ts.metallic.color) {
        var mp = window.ddbMetallicPrices && window.ddbMetallicPrices[ts.metallic.color];
        if (mp) t += mp / 100;
      }
      if (ts.number.active && ts.number.color && ts.number.number) {
        var np = window.ddbCandlePrices && window.ddbCandlePrices[ts.number.color];
        var nDigits = String(ts.number.number).replace(/\D/g, '').length || 1;
        if (np) t += (np / 100) * nDigits;
      }
    }
    Object.keys(state.extras).forEach(function (k) {
      if (state.extras[k].selected) t += state.extras[k].price;
    });
    return t;
  }

  function submitCart() {
    if (!state.variantId) { showStepError('ddb-step-review', '⚠️ Please choose a size first.'); return; }
    if (!state.flavor)    { showStepError('ddb-step-review', '⚠️ Please choose a flavor first.'); return; }

    if (state.candles.selected) {
      var ts = state.candles.types;
      var anyActive = ts.rainbow.active || ts.sparklers.active || ts.metallic.active || ts.number.active;
      if (!anyActive) {
        showStepError('ddb-step-review', '⚠️ You selected candles but no type — please choose rainbow, metallic, number, or sparklers, or deselect candles.');
        return;
      }
      if (ts.metallic.active && !ts.metallic.color) {
        showStepError('ddb-step-review', '⚠️ Please choose a color for your metallic candles, or deselect them.');
        return;
      }
      if (ts.number.active && !ts.number.color) {
        showStepError('ddb-step-review', '⚠️ Please choose a color for your number candles, or deselect them.');
        return;
      }
      if (ts.number.active && !ts.number.number) {
        showStepError('ddb-step-review', '⚠️ Please enter a number for your number candles, or deselect them.');
        var cn = document.getElementById('ddb-candle-number');
        if (cn) cn.focus();
        return;
      }
    }

    var atc = document.getElementById('ddb-btn-atc');
    if (atc) { atc.disabled = true; atc.textContent = 'Adding...'; }

    var capturedDims = null;
    if (cfg.hasPhotoUpload && state.photoUploaded && state.cropperInstance) {
      try {
        var squareCanvas = state.cropperInstance.getCroppedCanvas({
          maxWidth:  1200,
          maxHeight: 1200,
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high'
        });
        if (squareCanvas) {
          var size  = Math.min(squareCanvas.width, squareCanvas.height);
          var round = document.createElement('canvas');
          round.width  = size;
          round.height = size;
          var ctx = round.getContext('2d');
          ctx.beginPath();
          ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.clip();
          var dx = (size - squareCanvas.width)  / 2;
          var dy = (size - squareCanvas.height) / 2;
          ctx.drawImage(squareCanvas, dx, dy);

          capturedDims = { width: size, height: size };
          state.photoPendingCanvas = round;
        }
      } catch (e) {
        dwarn('[ddb] getCroppedCanvas threw:', e);
      }
    }

    if (state.cropperInstance) {
      try { state.cropperInstance.destroy(); } catch (e) {}
      state.cropperInstance = null;
    }

    var expectedTotal = promisedTotal();
    console.group('[ddb] submitCart diagnostics');
    dlog('Builder promised total: $' + expectedTotal.toFixed(2));
    dlog('Base variant:', state.variantId, '— $' + state.basePrice.toFixed(2));
    dlog('State snapshot:', JSON.parse(JSON.stringify(state, function (k, v) {
      if (k === 'photoPendingCanvas') return '[canvas]';
      return v;
    })));
    dlog('window.ddbFlavorVariants has', Object.keys(window.ddbFlavorVariants || {}).length, 'entries');
    dlog('window.ddbOptionVariants has', Object.keys(window.ddbOptionVariants || {}).length, 'entries');
    if (window.ddbOptionVariants) dlog('Available option variants:', Object.keys(window.ddbOptionVariants));
    console.groupEnd();

    function doPhotoUpload() {
      var cv = state.photoPendingCanvas;
      if (!cv) {
        /* No cropped canvas (Cropper never loaded) — the order still
           gets the photo via the raw upload started on file-select. */
        return (state.photoRawPromise || Promise.resolve(null));
      }
      if (atc) atc.textContent = 'Uploading photo…';
      dlog('[ddb] Photo capture ready — canvas is ' + cv.width + '×' + cv.height);

      var upload = new Promise(function (resolve, reject) {
        try {
          cv.toBlob(function (blob) {
            if (!blob) return reject(new Error('Blob conversion returned null'));
            dlog('[ddb] Uploading ' + Math.round(blob.size/1024) + ' KB to Cloudinary…');
            var form = new FormData();
            form.append('file',          blob, 'cake-photo.png');
            form.append('upload_preset', CLOUDINARY_PRESET);
            fetch(CLOUDINARY_URL, { method: 'POST', body: form })
              .then(function (r) {
                if (!r.ok) throw new Error('Cloudinary HTTP ' + r.status);
                return r.json();
              })
              .then(function (data) {
                if (!data || !data.secure_url) {
                  return reject(new Error('Cloudinary returned no URL: ' + JSON.stringify(data).slice(0, 200)));
                }
                state.photoUrl       = data.secure_url;
                state.photoUrlWidth  = data.width  || cv.width;
                state.photoUrlHeight = data.height || cv.height;
                dlog('[ddb] ✓ Photo uploaded:', data.secure_url);
                resolve(data);
              })
              .catch(reject);
          }, 'image/png');
        } catch (e) { reject(e); }
      });

      var timeout = new Promise(function (resolve) {
        setTimeout(function () {
          dwarn('[ddb] Upload timeout (8s) — proceeding without URL');
          resolve(null);
        }, 8000);
      });

      return Promise.race([upload, timeout])
        .catch(function (err) {
          dwarn('[ddb] Upload error:', err && err.message);
          return null;
        })
        .then(function (res) {
          if (state.photoUrl) return res;
          /* Cropped upload failed or timed out — fall back to the raw
             photo we began uploading the moment the file was picked. */
          return (state.photoRawPromise || Promise.resolve(null));
        });
    }

    doPhotoUpload().then(function () {
      if (atc) atc.textContent = 'Adding...';
    var builtProps = buildProperties();
    dlog('[ddb] Line item properties being sent to cart:', builtProps);
    dlog('[ddb] Photo URL on state:', state.photoUrl);
    dlog('[ddb] Photo uploaded flag:', state.photoUploaded);
    dlog('[ddb] Cropper instance:', !!state.cropperInstance);
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({
        items: [{ id: parseInt(state.variantId), quantity: 1, properties: builtProps }]
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        if (atc) { atc.textContent = 'Add to cart'; atc.disabled = false; }
        showCartError('Something went wrong: ' + (data.description || 'Please try again.'));
        console.error('[ddb] base cake add failed:', data);
        return;
      }
      var cakeKey = data.items && data.items[0] && data.items[0].key ? data.items[0].key : null;
      var addons  = buildAddonItems(cakeKey);
      dlog('[ddb] Cake added. Cake key:', cakeKey);
      dlog('[ddb] Sending', addons.length, 'add-on line items:', addons);

      if (!addons.length) { return verifyAndFinish(atc, expectedTotal); }
      return fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ items: addons })
      })
      .then(function (r) { return r.json(); })
      .then(function (addonData) {
        if (addonData.status) {
          console.error('[ddb] ADD-ON POST FAILED:', addonData);
          showCartError('Some extras couldn\'t be added: ' + (addonData.description || 'Please try again or contact us.'));
          if (atc) { atc.textContent = 'Add to cart'; atc.disabled = false; }
          return;
        }
        dlog('[ddb] Add-on items confirmed:', addonData);
        verifyAndFinish(atc, expectedTotal);
      });
    })
    .catch(function (err) {
      console.error('[ddb] cart error:', err);
      showCartError('We couldn\'t reach the cart. Check your connection and try again.');
      if (atc) { atc.textContent = 'Add to cart'; atc.disabled = false; }
    });
    });
  }

  function verifyAndFinish(atc, expectedTotal) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cakeItems = cart.items.filter(function (i) {
          return !(i.properties && i.properties._addon_for);
        });
        var latestCake = cakeItems[cakeItems.length - 1];
        var cakeKey = latestCake ? latestCake.key : null;
        var related = cart.items.filter(function (i) {
          return i.key === cakeKey || (i.properties && i.properties._addon_for === cakeKey);
        });
        var actualTotal = related.reduce(function (s, i) { return s + (i.line_price / 100); }, 0);

        console.group('[ddb] cart verification');
        dlog('Promised by builder: $' + expectedTotal.toFixed(2));
        dlog('Actual in cart:      $' + actualTotal.toFixed(2));
        dlog('Difference:          $' + (expectedTotal - actualTotal).toFixed(2));
        dlog('Cart line items for this cake:');
        related.forEach(function (i) {
          dlog('  · ' + i.product_title + ' — ' + i.variant_title + ' × ' + i.quantity + ' = $' + (i.line_price / 100).toFixed(2));
        });
        console.groupEnd();

        if (Math.abs(expectedTotal - actualTotal) > 0.02) {
          var diff = (expectedTotal - actualTotal).toFixed(2);
          dwarn('[ddb] PRICE MISMATCH — builder promised $' + expectedTotal.toFixed(2)
            + ', cart has $' + actualTotal.toFixed(2) + ' (diff $' + diff + '). '
            + 'Some add-on variants likely failed to resolve. Check the add-on POST log above.');
        }
        onCartSuccess(atc, cart);
      })
      .catch(function (err) {
        console.error('[ddb] cart verify error:', err);
        onCartSuccess(atc);
      });
  }

  function onCartSuccess(atc, cart) {
    if (atc) atc.textContent = 'Added! ✓';
    /* Update the badge + dispatch refresh first so the header cart count
       updates visually before navigation. Then redirect to /cart so the
       customer sees what they just added (instead of staying on the
       product page wondering if it worked). */
    if (cart) {
      updateBadgeFromCart(cart);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      setTimeout(function () { window.location.href = '/cart'; }, 400);
    } else {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          updateBadgeFromCart(c);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: c } }));
        })
        .catch(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .finally(function () {
          setTimeout(function () { window.location.href = '/cart'; }, 400);
        });
    }
  }

  function updateBadgeFromCart(cart) {
    var n = 0;
    cart.items.forEach(function (item) {
      var isAddon = item.properties && Object.keys(item.properties).some(function (k) { return k === '_addon_for'; });
      if (!isAddon) n += item.quantity;
    });
    document.querySelectorAll('.dbn-cart-badge').forEach(function (el) {
      el.textContent = n; el.style.display = n > 0 ? '' : 'none';
    });
  }

  function updatePrice() {
    /* Multi-flavor: sum surcharges across all picked slots. */
    var flavorTotalUp = 0;
    if (state.flavorPrices && state.flavorPrices.length > 0) {
      for (var fpu = 0; fpu < state.flavorPrices.length; fpu++) {
        flavorTotalUp += (state.flavorPrices[fpu] || 0);
      }
    } else {
      flavorTotalUp = state.flavorPrice || 0;
    }
    var total = state.basePrice + flavorTotalUp;
    if (state.diet.gf) total += 15;
    /* Fully frosted is +$10 — added to the running total here so the
       bottom-bar reflects the real price the customer will pay. The
       actual upcharge is added to the cart as a separate Shopify
       line item (Heart Cake Custom Options → "Fully Frosted" variant)
       in buildAddonItems below, so the price stays in sync. */
    if (cfg.hasNakedOption && state.nakedChoice === 'frosted') total += 10;
    if (cfg.hasPipingColor && state.piping.enabled) total += 5;
    if (state.sprinkle.price) total += state.sprinkle.price;
    if (state.letterColorCustomFee) total += state.letterColorCustomFee;
    Object.keys(state.customColorPrices).forEach(function (k) {
      if (state.customColorPrices[k] > 0) total += state.customColorPrices[k];
    });
    if (state.candles.selected) {
      var pts = state.candles.types;
      if (pts.rainbow.active   && window.ddbRainbowPrice)  total += window.ddbRainbowPrice  / 100;
      if (pts.sparklers.active && window.ddbSparklerPrice) total += window.ddbSparklerPrice / 100;
      if (pts.metallic.active && pts.metallic.color) {
        var pmp = window.ddbMetallicPrices && window.ddbMetallicPrices[pts.metallic.color];
        if (pmp) total += pmp / 100;
      }
      if (pts.number.active && pts.number.color && pts.number.number) {
        var pnp = window.ddbCandlePrices && window.ddbCandlePrices[pts.number.color];
        var pDigits = String(pts.number.number).replace(/\D/g, '').length || 1;
        if (pnp) total += (pnp / 100) * pDigits;
      }
    }
    Object.keys(state.extras).forEach(function (k) {
      if (state.extras[k].selected) total += state.extras[k].price;
    });
    var priceEl = document.getElementById('ddb-price-val');
    var labelEl = document.getElementById('ddb-price-label');
    if (priceEl) priceEl.textContent = total > 0 ? '$' + total.toFixed(2) : 'From $—';
    if (labelEl) {
      var label = state.sizeName || 'Choose your size';
      /* For mini/bento cakes, "Default Title" is the literal variant
         title from Shopify (since we collapsed bentos to single-variant
         products). It's ugly customer-facing — replace it with a clean
         "Bento Cake" label. */
      if (label === 'Default Title' || /^default title$/i.test(label)) {
        label = 'Bento Cake';
      }
      labelEl.textContent = label;
    }
  }

  /* Summary helpers — used by the review screen. */
  var STYLE_FONT = {
    fondant: "'CooperBlack', Georgia, serif",
    cursive: "'Sweet Charm', 'Brush Script MT', cursive",
    block:   "'Please Write Me A Song', 'Comic Sans MS', sans-serif",
    groovy:  "'Abstract Groovy', 'Impact', sans-serif"
  };

  function colorHex(colorName) {
    if (!colorName) return null;
    if (typeof colorName === 'string' && colorName.indexOf('Custom: ') === 0) return colorName.replace('Custom: ', '').trim();
    if (typeof colorName === 'string' && colorName.indexOf('Custom ') === 0)  return colorName.replace('Custom ', '').trim();
    var sw = document.querySelector('.ddb-swatch[data-color="' + colorName + '"]');
    if (sw && sw.dataset.bg) return sw.dataset.bg;
    var lsw = document.querySelector('.ddb-letter-swatch[data-letter="' + colorName + '"]');
    if (lsw && lsw.dataset.letterHex) return lsw.dataset.letterHex;
    /* Bow + flower swatches don't use .ddb-swatch or [data-color] anymore
       (they were migrated to flower-card layout with photos), so look
       them up by their dedicated data attributes. */
    var bsw = document.querySelector('.ddb-bow-swatch[data-bow-color="' + colorName + '"]');
    if (bsw && bsw.dataset.bg) return bsw.dataset.bg;
    var fsw = document.querySelector('.ddb-flower-swatch[data-flower-color="' + colorName + '"]');
    if (fsw && fsw.dataset.bg) return fsw.dataset.bg;
    return null;
  }
  function setThumbColor(id, hex) {
    var el = document.getElementById(id);
    if (!el) return;
    el.style.backgroundColor = hex || '';
  }
  function setThumbImg(id, urlOrCss) {
    var el = document.getElementById(id);
    if (!el) return;
    if (urlOrCss) {
      el.style.backgroundImage = urlOrCss.indexOf('url(') === 0 ? urlOrCss : 'url(' + urlOrCss + ')';
    } else {
      el.style.backgroundImage = '';
    }
  }
  /* Pull the actual image URL out of a selected swatch/card so the
     review summary can render the same photo the customer picked
     (instead of a flat color square). Used for bow, flower, sprinkle. */
  /* Pull the actual image URL out of a selected swatch/card so the
     review summary can render the same photo the customer picked.
     We accept the src even if naturalWidth is 0 — the image might
     just not be loaded yet, but setting it as a background image
     will trigger its own fetch + cache it for the customer. Only
     reject if the image element has been explicitly hidden by the
     onerror handler (style.display === 'none'). */
  function imageFromCard(selector) {
    var card = document.querySelector(selector);
    if (!card) return null;
    var img = card.querySelector('img');
    if (!img || !img.src) return null;
    if (img.style.display === 'none') return null;
    return img.src;
  }
  function setFontStyle(id, fontFamily, color) {
    var el = document.getElementById(id);
    if (!el) return;
    if (fontFamily) el.style.fontFamily = fontFamily;
    if (color) el.style.color = color;
  }

  /* Renders the new stacked color-change list in the review summary.
     Each line shows: [original swatch ✗] → [new swatch] Original → New
     For "Keep" picks: just [new swatch] Name — kept
     Replaces the old color preview bar. */
  function renderReviewColorList() {
    var container = document.getElementById('ddb-sum-color-list');
    if (!container) return;
    var count = cfg.colorCount || 1;
    var lines = [];
    for (var i = 1; i <= count; i++) {
      var stateVal = state.colors[i] || state.colors[String(i)];
      var orig = slotOriginal(i);
      var origName = orig ? orig.name : 'Color ' + i;
      var origHex  = orig ? orig.hex  : '#cccccc';
      var lightOrig = isLightHex(origHex);

      if (!stateVal) {
        lines.push(
          '<div class="ddb-color-change">' +
          '<span class="ddb-cc-pending">' + escapeHtml(origName) + ' — not picked</span>' +
          '</div>'
        );
        continue;
      }

      if (typeof stateVal === 'string' && stateVal.indexOf('Keep ') === 0) {
        /* Kept — single swatch */
        lines.push(
          '<div class="ddb-color-change">' +
          '<span class="ddb-cc-swatch" style="background:' + origHex + ';' +
          (lightOrig ? 'border:1px solid rgba(0,0,0,0.18);' : '') + '"></span>' +
          '<span class="ddb-cc-text"><strong>' + escapeHtml(origName) + '</strong> — kept</span>' +
          '</div>'
        );
        continue;
      }

      /* Replaced */
      var newName, newHex;
      if (typeof stateVal === 'string' && stateVal.indexOf('Custom: ') === 0) {
        newHex = stateVal.substring(8);
        newName = 'Custom <code>' + escapeHtml(newHex) + '</code>';
      } else {
        newName = escapeHtml(stateVal);
        newHex = hexForColorName(stateVal) || '#cccccc';
      }
      var lightNew = isLightHex(newHex);
      lines.push(
        '<div class="ddb-color-change">' +
        '<span class="ddb-cc-swatch ddb-cc-swatch--orig" style="background:' + origHex + ';' +
        (lightOrig ? 'border:1px solid rgba(0,0,0,0.18);' : '') + '">' +
        '<span class="ddb-cc-strike" aria-hidden="true"></span>' +
        '</span>' +
        '<span class="ddb-cc-arrow">→</span>' +
        '<span class="ddb-cc-swatch" style="background:' + newHex + ';' +
        (lightNew ? 'border:1px solid rgba(0,0,0,0.18);' : '') + '"></span>' +
        '<span class="ddb-cc-text"><strong>' + escapeHtml(origName) + '</strong> → ' + newName + '</span>' +
        '</div>'
      );
    }
    container.innerHTML = lines.join('');
  }

  function updateSummary() {
    setText('ddb-sum-size',    state.sizeName || '—');
    /* Multi-flavor summary: show all picked flavors comma-separated. */
    var slotCount = flavorSlotCount();
    if (slotCount > 1 && state.flavors && state.flavors.length > 0) {
      var parts = [];
      for (var sm = 0; sm < slotCount; sm++) {
        var f = state.flavors[sm];
        if (!f) continue;
        var prefix = (slotCount === 2)
          ? (sm === 0 ? 'Bottom: ' : 'Top: ')
          : ('Cake ' + (sm + 1) + ': ');
        parts.push(prefix + f);
      }
      setText('ddb-sum-flavor', parts.length ? parts.join(' · ') : '—');
    } else {
      setText('ddb-sum-flavor', state.flavor || '—');
    }
    if (state.flavor) {
      var fcard = document.querySelector('.ddb-flavor-item[data-flavor="' + state.flavor + '"] img');
      if (fcard && fcard.src) setThumbImg('ddb-sum-thumb-flavor', fcard.src);
    }

    var sumDietParts = [];
    if (state.diet.gf)  sumDietParts.push('Gluten-Free (+$15)');
    if (state.diet.nut) sumDietParts.push('Nut Allergy');
    setText('ddb-sum-diet',    sumDietParts.length ? sumDietParts.join(' + ') : 'None');

    if (cfg.hasNakedOption) {
      setText('ddb-sum-naked', state.nakedChoice === 'naked' ? 'Naked' : state.nakedChoice === 'frosted' ? 'Fully frosted (+$10)' : '—');
    }

    if (cfg.hasBowColor) {
      setText('ddb-sum-bow-color', state.bowColor || '—');
      /* Use a color square (not the ribbon photo) — photos are too
         small at thumb size to read clearly. The color name + hex is
         a cleaner visual cue. */
      var bowHex = colorHex(state.bowColor);
      if (bowHex) setThumbColor('ddb-sum-thumb-bow', bowHex);
    }

    if (cfg.hasFlowerColor) {
      setText('ddb-sum-flower-color', state.flowerColor || '—');
      var flowerImg = imageFromCard('.ddb-flower-swatch.is-selected');
      if (flowerImg) {
        setThumbImg('ddb-sum-thumb-flower', flowerImg);
        setThumbColor('ddb-sum-thumb-flower', '');
      } else {
        var flowerHex = colorHex(state.flowerColor);
        if (flowerHex) setThumbColor('ddb-sum-thumb-flower', flowerHex);
      }
    }

    if (cfg.cakeHasPearls) {
      var pearlLabel = state.pearlChoice
        ? (state.pearlChoice === 'None' ? 'No pearls' : state.pearlChoice + ' pearls')
        : '—';
      setText('ddb-sum-pearls', pearlLabel);
      var pearlThumb = document.getElementById('ddb-sum-thumb-pearls');
      var pearlImg = imageFromCard('.ddb-pearl-swatch.is-selected');
      if (pearlImg && pearlThumb) {
        setThumbImg('ddb-sum-thumb-pearls', pearlImg);
        setThumbColor('ddb-sum-thumb-pearls', '');
      } else if (pearlThumb) {
        /* No image (None pick, or nothing picked) — clear any prior img. */
        pearlThumb.style.backgroundImage = '';
        setThumbColor('ddb-sum-thumb-pearls', '#f5f5f5');
      }
    }

    if (cfg.accent1Label) {
      var a1parts = [];
      for (var ai1 = 1; ai1 <= (cfg.accent1Count || 1); ai1++) {
        a1parts.push(state.accent1[ai1] || '—');
      }
      setText('ddb-sum-accent1', a1parts.join(' + '));
    }

    if (cfg.accent2Label) {
      var a2parts = [];
      for (var ai2 = 1; ai2 <= (cfg.accent2Count || 1); ai2++) {
        a2parts.push(state.accent2[ai2] || '—');
      }
      setText('ddb-sum-accent2', a2parts.join(' + '));
    }

    if (cfg.hasColors) {
      var colorCount = cfg.colorCount || 1;
      if (colorCount === 1) {
        /* Single-color cake — legacy single-line summary. */
        var c1 = state.colors['1'] || state.colors[1];
        setText('ddb-sum-color', c1 || '—');
        var c1hex = colorHex(c1);
        if (c1hex) setThumbColor('ddb-sum-thumb-color', c1hex);
      } else {
        /* Multi-color — render stacked change list. */
        renderReviewColorList();
      }
    }

    if (cfg.hasPipingColor && cfg.colorCount === 1) {
      setText('ddb-sum-piping', state.piping.enabled && state.piping.color ? state.piping.color + ' (+$5)' : 'Match cake');
    }

    if (cfg.hasSprinkles) {
      var sum = state.sprinkle.name || '—';
      if (state.sprinkle.price > 0) sum += ' (+$' + state.sprinkle.price.toFixed(0) + ')';
      setText('ddb-sum-sprinkles', sum);
      /* Try to grab the photo from the selected sprinkle card; if it's
         a "No sprinkles" pick or there's no image, leave the emoji
         fallback baked into the markup. */
      var sprinkleImg = imageFromCard('.ddb-sprinkle-card.is-selected');
      var sprinkleThumb = document.getElementById('ddb-sum-thumb-sprinkles');
      if (sprinkleImg && sprinkleThumb) {
        setThumbImg('ddb-sum-thumb-sprinkles', sprinkleImg);
        /* Hide the ✨ emoji text once we have a real photo. */
        sprinkleThumb.textContent = '';
        sprinkleThumb.style.backgroundColor = '#fff';
        sprinkleThumb.style.backgroundSize = 'cover';
        sprinkleThumb.style.backgroundPosition = 'center';
      } else if (sprinkleThumb) {
        /* No image (e.g., "No sprinkles" picked) — restore emoji fallback. */
        sprinkleThumb.style.backgroundImage = '';
        if (!sprinkleThumb.textContent.trim()) sprinkleThumb.textContent = '✨';
      }
    }

    if (cfg.hasPhotoUpload) {
      var photoLabel = 'Not uploaded';
      if (state.photoUploaded) {
        photoLabel = state.photoLocked ? 'Locked ✓' : 'Uploaded — not locked';
      }
      setText('ddb-sum-photo', photoLabel);
      /* Prefer the locked circular crop for the summary thumb — it's
         what actually prints. Fall back to the raw upload. */
      var lockedSumImg = document.getElementById('ddb-photo-locked-img');
      if (state.photoUploaded && state.photoLocked && lockedSumImg && lockedSumImg.src) {
        setThumbImg('ddb-sum-thumb-photo', lockedSumImg.src);
      } else if (state.photoUploaded && state.photoDataUrl) {
        setThumbImg('ddb-sum-thumb-photo', state.photoDataUrl);
      }
    }

    if (cfg.hasLetterStyles) {
      var styleLabel = { groovy: 'Groovy letters', fondant: 'Fondant letters', cursive: 'Buttercream cursive', block: 'Buttercream block', none: 'No text' }[state.letterStyle] || '—';
      setText('ddb-sum-letter-style', styleLabel);
      if (state.letterStyle && state.letterStyle !== 'none' && STYLE_FONT[state.letterStyle]) {
        setFontStyle('ddb-sum-thumb-text', STYLE_FONT[state.letterStyle], '#0c0c0e');
      }
    }

    var msgSummary;
    if (cfg.hasLetterStyles && state.letterStyle) {
      if (state.letterStyle === 'none') {
        msgSummary = '—';
      } else if (state.letterStyle === 'groovy' || state.letterStyle === 'fondant') {
        msgSummary = [state.msgLines.l1, state.msgLines.l2, state.msgLines.l3].filter(Boolean).join(' / ') || '—';
      } else {
        msgSummary = state.msgFreeform || '—';
      }
    } else {
      msgSummary = state.message || (cfg.messageOptional ? 'No message' : '—');
    }
    setText('ddb-sum-message', msgSummary);

    if (cfg.hasLetterColors && state.letterStyle && state.letterStyle !== 'none' && state.letterStyle !== 'groovy') {
      var letterDisplay, letterHex;
      if (cfg.letterColorMatchesColor && state.colors[String(cfg.letterColorMatchesColor)]) {
        var matchedStateVal = state.colors[String(cfg.letterColorMatchesColor)];
        if (typeof matchedStateVal === 'string' && matchedStateVal.indexOf('Keep ') === 0) {
          letterDisplay = 'Matches Color ' + cfg.letterColorMatchesColor + ' (' + matchedStateVal.substring(5) + ' — kept)';
        } else {
          letterDisplay = 'Matches Color ' + cfg.letterColorMatchesColor + ' (' + matchedStateVal + ')';
        }
        letterHex = colorHex(matchedStateVal);
      } else if (cfg.letterColorMatchesBow && state.bowColor) {
        letterDisplay = 'Matches bow (' + state.bowColor + ')';
        letterHex = colorHex(state.bowColor);
      } else if (state.letterColor === 'Custom') {
        letterDisplay = 'Custom (' + (state.letterColorCustomHex || '') + ') +$5';
        letterHex = state.letterColorCustomHex || '';
      } else {
        letterDisplay = state.letterColor || '—';
        letterHex = colorHex(state.letterColor);
      }
      setText('ddb-sum-letter-color', letterDisplay);
      setThumbColor('ddb-sum-thumb-letter', letterHex);

      var msgEl = document.getElementById('ddb-sum-message');
      if (msgEl) {
        msgEl.style.fontFamily = STYLE_FONT[state.letterStyle] || '';
        msgEl.style.color = (letterHex && state.letterColor !== 'Like Image') ? letterHex : '';
      }
    } else {
      var msgEl2 = document.getElementById('ddb-sum-message');
      if (msgEl2 && state.letterStyle && state.letterStyle !== 'none' && STYLE_FONT[state.letterStyle]) {
        msgEl2.style.fontFamily = STYLE_FONT[state.letterStyle];
      }
    }

    if (cfg.extraMessageLabel) {
      setText('ddb-sum-extra-msg', state.extraMessage || '—');
    }

    if (cfg.hasNumber) {
      setText('ddb-sum-number', state.cakeNumber || '—');
    }
  }

  function setText(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  function syncVariantInput() {
    var input = document.getElementById('ddb-variant-id');
    if (input) input.value = state.variantId;
  }

})();

/* ═══════════════════════════════════════════════════════════
   Cart badge polling
   ═══════════════════════════════════════════════════════════ */
(function () {
  function refreshBadge() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0;
        cart.items.forEach(function (item) {
          var isAddon = item.properties && Object.keys(item.properties).some(function (k) { return k === '_addon_for'; });
          if (!isAddon) n += item.quantity;
        });
        document.querySelectorAll('.dbn-cart-badge').forEach(function (el) {
          el.textContent = n;
          el.style.display = n > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }
  if (document.readyState === 'complete') refreshBadge();
  else window.addEventListener('load', refreshBadge);
  document.addEventListener('cart:change',  refreshBadge);
  document.addEventListener('cart:refresh', refreshBadge);
  setInterval(refreshBadge, 2000);
})();

/* ═══════════════════════════════════════════════════════════
   Orphan add-on cleanup
   ═══════════════════════════════════════════════════════════ */
(function () {
  function cleanupOrphanAddons() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var validKeys = {};
        cart.items.forEach(function (item) {
          var isAddon = item.properties && item.properties._addon_for;
          if (!isAddon) validKeys[item.key] = true;
        });
        var orphans = cart.items.filter(function (item) {
          var parent = item.properties && item.properties._addon_for;
          return parent && !validKeys[parent];
        });
        if (!orphans.length) return;
        var chain = Promise.resolve();
        orphans.forEach(function (item) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method:  'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body:    JSON.stringify({ id: item.key, quantity: 0 })
            });
          });
        });
        chain.then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
      })
      .catch(function () {});
  }
  if (document.readyState === 'complete') cleanupOrphanAddons();
  else window.addEventListener('load', cleanupOrphanAddons);
  document.addEventListener('cart:change',  cleanupOrphanAddons);
  document.addEventListener('cart:refresh', cleanupOrphanAddons);
  setInterval(cleanupOrphanAddons, 5000);
})();

/* ────────────────────────────────────────────────────────────────────────────
   Chat-widget opener for "contact us" links inside allergy notices.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  function openChatWidget(context) {
    if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
      window.tidioChatApi.open();
      if (context && typeof window.tidioChatApi.messageFromVisitor === 'function') {
        try { window.tidioChatApi.messageFromVisitor('Question about ' + context); } catch (e) {}
      }
      return true;
    }
    if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
      window.GorgiasChat.open();
      return true;
    }
    if (window.$crisp && typeof window.$crisp.push === 'function') {
      window.$crisp.push(['do', 'chat:open']);
      return true;
    }
    if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
      window.ShopifyChat.open();
      return true;
    }
    if (typeof window.Intercom === 'function') {
      window.Intercom('show');
      return true;
    }
    if (window.drift && typeof window.drift.api === 'object' && typeof window.drift.api.openChat === 'function') {
      window.drift.api.openChat();
      return true;
    }
    if (window.LC_API && typeof window.LC_API.open_chat_window === 'function') {
      window.LC_API.open_chat_window();
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.ddb-open-chat');
    if (!trigger) return;
    e.preventDefault();
    var context = trigger.getAttribute('data-chat-context') || '';
    var opened = openChatWidget(context);
    if (!opened) {
      window.location.href = '/pages/contact';
    }
  });
})();

/* ────────────────────────────────────────────────────────────────────────────
   Color reference gallery toggle.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.ddb-color-guide-toggle');
    if (!toggle) return;
    var panelId = toggle.getAttribute('aria-controls');
    if (!panelId) return;
    var panel = document.getElementById(panelId);
    if (!panel) return;
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (isOpen) panel.setAttribute('hidden', '');
    else panel.removeAttribute('hidden');
  });
})();

/* ────────────────────────────────────────────────────────────────────────────
   Per-handle photo step title + subtitle override. Some cakes need custom
   wording on the photo upload step — e.g. cakes with a logo or motif the
   customer is REPLACING with their own image. Add a handle entry below.
     - Each value can be an OBJECT { title, subtitle } to override either
       or both, OR a plain STRING (legacy) which overrides the subtitle only.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var PHOTO_OVERRIDES = {
    'college-themed-cake': {
      subtitle: "Upload the image you want printed on the sugar plaque on the cake (to replace the logo shown)."
    },
    'fiu-cake': {
      title:    "Your logo or image",
      subtitle: "We'll print it on edible sugar plaque — it will replace the FIU logo on the cake."
    }
    /* Add more cake handles here as needed. Use { title, subtitle } to
       override either or both. A plain string overrides the subtitle only. */
  };

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  function applyPhotoOverride() {
    var handle = getHandle();
    var ov = PHOTO_OVERRIDES[handle];
    if (!ov) return;
    /* Normalize legacy string form → { subtitle }. */
    if (typeof ov === 'string') ov = { subtitle: ov };

    var step = document.getElementById('ddb-step-photo');
    if (!step) return;

    if (ov.title) {
      var titleEl = step.querySelector('.ddb-step-title');
      if (titleEl && titleEl.dataset.ddbCustomized !== '1') {
        titleEl.textContent = ov.title;
        titleEl.dataset.ddbCustomized = '1';
      }
    }
    if (ov.subtitle) {
      var sub = step.querySelector('.ddb-step-sub');
      if (sub && sub.dataset.ddbCustomized !== '1') {
        sub.textContent = ov.subtitle;
        sub.dataset.ddbCustomized = '1';
      }
    }
  }

  function tryApply() {
    applyPhotoOverride();
    setTimeout(applyPhotoOverride, 500);
    setTimeout(applyPhotoOverride, 1500);
    setTimeout(applyPhotoOverride, 3000);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryApply();
  } else {
    document.addEventListener('DOMContentLoaded', tryApply);
    window.addEventListener('load', tryApply);
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Macaron-on-cake flag (JS-side hardcoded, no Liquid dependency).
   Some cakes ship with macarons on top — macarons contain almond flour,
   so when the customer flags Nut Allergy on those cakes, we need to:
     1. Show an extra paragraph in the nut warning explaining the macarons
        will be removed (or substituted) so the cake stays nut-free
     2. Tag the cart line items with a "Macarons: <note> (nut allergy)"
        property so the kitchen sees the flag at fulfillment
   This used to be done via Liquid by-handle hardcoding, but to avoid the
   Liquid deployment issues we move the source of truth into JS. The
   Liquid path still works as a fallback; this overrides if both are set.
   Add/edit cakes in MACARON_CAKES below.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var MACARON_CAKES = {
    /* Group A — macarons removed entirely (no substitute) */
    'floral-naked-cake':                            "We'll remove them",
    'black-silver-balloon-extravaganza':            "We'll remove them",
    'balloon-galore':                               "We'll remove them",
    'gold-balloon-extravaganza':                    "We'll remove them",
    'blue-gold-balloon-extravaganza':               "We'll remove them",
    'metallic-pink-rose-gold-balloon-extravaganza': "We'll remove them",
    'blessed-in-gold':                              "We'll remove them",
    'midnight-cake':                                "We'll remove them",
    /* Group B — macarons replaced with extra buttercream ruffles (the
       macarons are integral to the design, so we substitute rather
       than just remove) */
    'marbled':       "We'll replace them with extra buttercream ruffles",
    'macaron-cake':  "We'll replace them with extra buttercream ruffles",
    'dream-fantasy': "We'll replace them with extra buttercream ruffles"
    /* Add more cake handles here. The value is the customer-facing
       removal note shown in the nut warning. */
  };

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  /* Step 1 — patch window.ddbProduct so the existing cart-property logic
     (in buildProperties below the IIFE chain) sees the correct flags.
     Runs immediately, before any user interaction with the diet step. */
  (function applyCfgOverride() {
    var handle = getHandle();
    if (!handle) return;
    var note = MACARON_CAKES[handle];
    if (!note) return;
    if (!window.ddbProduct) window.ddbProduct = {};
    window.ddbProduct.cakeHasMacarons = true;
    window.ddbProduct.macaronRemovalNote = note;
  })();

  /* Step 2 — inject the visible warning paragraph into the nut warning
     panel on the diet step. The Liquid version of this paragraph might
     not be present on the page (deployment issue), so we ensure it
     always renders on macaron cakes. Idempotent. */
  function injectNutWarningParagraph() {
    var handle = getHandle();
    var note = MACARON_CAKES[handle];
    if (!note) return;
    var warning = document.getElementById('ddb-nut-warning');
    if (!warning) return;
    if (warning.querySelector('.ddb-macaron-warning-injected')) return;
    /* Skip if Liquid already rendered the warning paragraph. */
    var paragraphs = warning.querySelectorAll('p');
    for (var i = 0; i < paragraphs.length; i++) {
      if (paragraphs[i].textContent.indexOf('About the macarons') !== -1) return;
    }

    var p = document.createElement('p');
    p.className = 'ddb-macaron-warning-injected';
    p.style.cssText = 'background:#fff;border:1px solid #E0CC9F;border-radius:6px;padding:10px 12px;margin-bottom:10px;';
    p.innerHTML =
      '<strong>🥜 About the macarons:</strong> This cake comes with macarons on top, which contain almonds. ' +
      '<strong>' + note + '</strong> so your cake stays nut-free.';

    /* Insert before the ack checkbox so the customer sees it before
       confirming. The ack lives at #ddb-nut-ack. */
    var ack = document.getElementById('ddb-nut-ack');
    if (ack && ack.parentNode === warning) {
      warning.insertBefore(p, ack);
    } else {
      warning.appendChild(p);
    }
  }

  function tryInject() {
    injectNutWarningParagraph();
    setTimeout(injectNutWarningParagraph, 300);
    setTimeout(injectNutWarningParagraph, 1000);
    setTimeout(injectNutWarningParagraph, 2500);
  }

  /* Also re-run when the nut warning becomes visible (the diet step
     toggles it via the is-visible class). */
  function watchNutWarning() {
    var warning = document.getElementById('ddb-nut-warning');
    if (!warning) {
      setTimeout(watchNutWarning, 500);
      return;
    }
    injectNutWarningParagraph();
    try {
      var obs = new MutationObserver(function () { injectNutWarningParagraph(); });
      obs.observe(warning, { attributes: true, attributeFilter: ['class'], childList: true, subtree: false });
    } catch (e) {
      setInterval(injectNutWarningParagraph, 1500);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryInject();
    watchNutWarning();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryInject(); watchNutWarning(); });
    window.addEventListener('load', function () { tryInject(); watchNutWarning(); });
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Ball-cake note injector — cakes decorated with chocolate/candy balls
   where the ball colors are FIXED (not customer-changeable) without
   pre-approval. Renders a purple disclaimer on the color step so the
   customer knows the cake color they pick won't affect the balls.
   Add new handles to BALL_CAKE_HANDLES below as you launch more.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var BALL_CAKE_HANDLES = [
    'black-gold-cake',
    'blue-gold-cake',
    'white-silver-and-blue-cake',
    'pink-beauty',
    'what-will-i-be',
    'fiu-cake'
  ];
  var BALL_NOTE = '⚠️ COLOR BALLS (not metallic) will stay the same color unless requested in advance and approved on the chat. Changing the color may incur additional fees and extra time may be required for this change.';

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  function injectBallNote() {
    var handle = getHandle();
    if (BALL_CAKE_HANDLES.indexOf(handle) === -1) return;
    var colorStep = document.getElementById('ddb-step-color');
    if (!colorStep) return;
    /* Idempotent — skip if we've already injected it. */
    if (colorStep.querySelector('.ddb-ball-note-injected')) return;

    /* Find an anchor — prefer the buttercream-handmade disclaimer; fall
       back to the ombré note if the customer's on an ombré ball cake;
       finally fall back to the step subtitle. */
    var anchor = null;
    var disclaimers = colorStep.querySelectorAll('.ddb-color-disclaimer');
    for (var i = 0; i < disclaimers.length; i++) {
      if (disclaimers[i].textContent.indexOf('handmade') !== -1) {
        anchor = disclaimers[i];
      }
    }
    /* If an ombré note exists, anchor AFTER it so the order reads:
       handmade → ombré → ball-warning. Tries last .ddb-ombre-note-injected. */
    var ombre = colorStep.querySelector('.ddb-ombre-note-injected');
    if (ombre) anchor = ombre;

    if (!anchor) anchor = colorStep.querySelector('.ddb-step-sub') || colorStep.firstChild;
    if (!anchor || !anchor.parentNode) return;

    var newNote = document.createElement('div');
    newNote.className = 'ddb-color-disclaimer ddb-ball-note-injected';
    newNote.setAttribute('role', 'note');
    /* Slightly warmer tone than the ombré note (orange-ish) to read as
       a caveat rather than design info. Still in the existing palette. */
    newNote.style.cssText = 'background:#fff0f0;color:#b91c1c;margin-top:8px;display:block;border:1px solid #e57373;';
    newNote.innerHTML = BALL_NOTE;

    anchor.parentNode.insertBefore(newNote, anchor.nextSibling);
  }

  function tryInject() {
    injectBallNote();
    setTimeout(injectBallNote, 500);
    setTimeout(injectBallNote, 1500);
    setTimeout(injectBallNote, 3000);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryInject();
  } else {
    document.addEventListener('DOMContentLoaded', tryInject);
    window.addEventListener('load', tryInject);
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Element note injector — single-color cakes that are ombré or have a
   specific element being colored. Reads the color_slot_elements metafield
   (exposed via window.ddbProduct.colorSlotElementsArr) and renders the
   FIRST entry as a purple note below the buttercream-handmade warning.

   This version uses a MutationObserver so it ALSO fires when the customer
   navigates to the color step, not just on initial page load. Catches any
   late-rendered DOM and survives navigation back-and-forth.

   Value sanitization: strips leading/trailing quotes, backticks, and
   apostrophes — Shopify CSV exports sometimes show them as part of the
   value, and the actual stored value can include them too. The injector
   is defensive so it always renders a clean note.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  /* Hardcoded per-handle notes — works regardless of whether the
     Liquid metafield render path is functioning. Add/edit entries
     here to update the ombré/element note for any single-color cake.
     Note: this takes precedence over the metafield-driven path, so
     if a handle is listed here, the JS value wins. */
  var HARDCODED_NOTES = {
    'blue-cloud-nine':            'Main color (fades to white)',
    'pink-cloud-nine':            'Main color (fades to white)',
    'happy-farm-cake':            'Main color (fades to white)',
    'under-the-sea':              'Main color (fades to white)',
    'wild-safari-adventure-cake': 'Main color (fades to white)',
    'deep-sea':                   'Main color (fades to a lighter shade)',
    'fairyland-cake':             'Main color (fades to a lighter shade)',
    'marbled':                    "Chosen color will replace the pink. Macarons match the cake color when possible \u2014 otherwise ivory."
  };

  function sanitizeNoteValue(s) {
    if (!s) return '';
    var v = String(s).trim();
    /* Strip wrapping quotes/apostrophes that may have leaked in from
       the Shopify CSV or copy-paste from another source. */
    while (v.length > 0 && (v.charAt(0) === "'" || v.charAt(0) === '"' || v.charAt(0) === '`')) {
      v = v.substring(1).trim();
    }
    while (v.length > 0 && (v.charAt(v.length - 1) === "'" || v.charAt(v.length - 1) === '"' || v.charAt(v.length - 1) === '`')) {
      v = v.substring(0, v.length - 1).trim();
    }
    return v;
  }

  function getElementNote() {
    var p = window.ddbProduct || {};
    var handle = p.handle || '';
    /* First check the hardcoded per-handle map (JS-only, no Liquid
       dependency — guaranteed to work). */
    if (handle && HARDCODED_NOTES[handle]) {
      return HARDCODED_NOTES[handle];
    }
    /* Fall back to the Liquid-exposed metafield array if present. */
    var arr = p.colorSlotElementsArr || [];
    if (!arr.length) return '';
    return sanitizeNoteValue(arr[0]);
  }

  function injectNote() {
    var note = getElementNote();
    if (!note) return;
    var colorStep = document.getElementById('ddb-step-color');
    if (!colorStep) return;
    /* Skip if already injected (by Liquid or a previous run). */
    if (colorStep.querySelector('.ddb-ombre-note-injected')) return;
    /* Also skip if Liquid already rendered a matching purple disclaimer
       (avoids double-notes when both paths succeed). */
    var existingDisclaimers = colorStep.querySelectorAll('.ddb-color-disclaimer');
    for (var j = 0; j < existingDisclaimers.length; j++) {
      if (existingDisclaimers[j].textContent.indexOf(note) !== -1) return;
    }

    /* Find the buttercream-handmade disclaimer to insert after. */
    var anchor = null;
    for (var i = 0; i < existingDisclaimers.length; i++) {
      if (existingDisclaimers[i].textContent.indexOf('handmade') !== -1) {
        anchor = existingDisclaimers[i];
        break;
      }
    }
    if (!anchor) anchor = existingDisclaimers[0];
    /* Last-resort fallback — insert right after the step subtitle. */
    if (!anchor) anchor = colorStep.querySelector('.ddb-step-sub');
    if (!anchor || !anchor.parentNode) return;

    var newNote = document.createElement('div');
    newNote.className = 'ddb-color-disclaimer ddb-ombre-note-injected';
    newNote.setAttribute('role', 'note');
    newNote.style.cssText = 'background:#f0e8f8;color:#4a2a60;margin-top:8px;display:block;';
    newNote.innerHTML = '🎨 <strong>' + note + '</strong>';
    anchor.parentNode.insertBefore(newNote, anchor.nextSibling);
  }

  function tryInject() {
    /* Run several times to catch late-rendered steps. */
    injectNote();
    setTimeout(injectNote, 200);
    setTimeout(injectNote, 800);
    setTimeout(injectNote, 2000);
    setTimeout(injectNote, 4000);
  }

  /* Set up a MutationObserver on the color step (or its parent) to catch
     class changes (is-active toggle when customer reaches the step). */
  function startObserver() {
    var colorStep = document.getElementById('ddb-step-color');
    if (!colorStep) {
      /* Color step not yet rendered — try again shortly. */
      setTimeout(startObserver, 500);
      return;
    }
    /* Initial inject. */
    injectNote();
    /* Watch for class changes (is-active toggled when step becomes visible) */
    try {
      var obs = new MutationObserver(function () {
        injectNote();
      });
      obs.observe(colorStep, { attributes: true, attributeFilter: ['class'], childList: true, subtree: false });
    } catch (e) {
      /* If MutationObserver throws (very old browser), fall back to polling. */
      setInterval(injectNote, 1000);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryInject();
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryInject(); startObserver(); });
    window.addEventListener('load', function () { tryInject(); startObserver(); });
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Gallery toggle robustness — extra binding directly on the button(s), in
   case the document-level delegated listener above is being blocked by
   something. Idempotent: marks bound buttons to avoid double-firing.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  function bindGalleryToggles() {
    var toggles = document.querySelectorAll('.ddb-color-guide-toggle');
    for (var i = 0; i < toggles.length; i++) {
      var t = toggles[i];
      if (t.dataset.ddbGalleryBound === '1') continue;
      t.dataset.ddbGalleryBound = '1';
      t.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var panelId = this.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        /* Fallback: find the next sibling .ddb-color-guide-panel. */
        if (!panel) {
          var next = this.nextElementSibling;
          while (next && !next.classList.contains('ddb-color-guide-panel')) {
            next = next.nextElementSibling;
          }
          panel = next;
        }
        if (!panel) return;
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) {
          panel.setAttribute('hidden', '');
        } else {
          panel.removeAttribute('hidden');
        }
      });
    }
  }

  function tryBind() {
    bindGalleryToggles();
    setTimeout(bindGalleryToggles, 500);
    setTimeout(bindGalleryToggles, 1500);
    setTimeout(bindGalleryToggles, 3000);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryBind();
  } else {
    document.addEventListener('DOMContentLoaded', tryBind);
    window.addEventListener('load', tryBind);
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Hot Pink hex update + Groovy Cake gallery entry (JS-injected so it lands
   even when Liquid changes don't deploy). Two operations:
     1. Update any palette swatch with name "Hot Pink" to the new hex
     2. Add a gallery tile for Hot Pink → Groovy Cake photo
   Both run idempotently and re-run via MutationObserver on the color step.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var HOT_PINK_HEX = '#FF2D7A';
  var GROOVY_PHOTO = 'https://dbakers.us/cdn/shop/files/groovy-cakedbakers-miami-5937517.png?v=1761177894';

  function updateHotPinkSwatches() {
    /* Find palette swatches with data-color="Hot Pink" and update both
       the data-bg attribute and the visible circle background. */
    var swatches = document.querySelectorAll('.ddb-swatch[data-color="Hot Pink"]');
    for (var i = 0; i < swatches.length; i++) {
      var sw = swatches[i];
      sw.setAttribute('data-bg', HOT_PINK_HEX);
      var circle = sw.querySelector('.ddb-swatch-circle');
      if (circle) {
        circle.style.background = HOT_PINK_HEX;
      }
    }
  }

  function addGroovyGalleryTile() {
    var galleries = document.querySelectorAll('.ddb-color-guide-grid');
    for (var g = 0; g < galleries.length; g++) {
      var grid = galleries[g];
      /* Skip if Hot Pink tile already exists in this gallery. */
      var exists = false;
      var names = grid.querySelectorAll('.ddb-color-guide-name-text');
      for (var n = 0; n < names.length; n++) {
        if (names[n].textContent.trim().toLowerCase() === 'hot pink') {
          exists = true;
          break;
        }
      }
      if (exists) continue;

      /* Build the new tile in the same shape as the Liquid template. */
      var tile = document.createElement('div');
      tile.className = 'ddb-color-guide-tile';
      tile.innerHTML =
        '<div class="ddb-color-guide-photo" style="background:' + HOT_PINK_HEX + ';">' +
          '<img src="' + GROOVY_PHOTO + '" alt="Real dbakers cake in Hot Pink buttercream" loading="lazy" decoding="async" onerror="this.style.display=\'none\';">' +
        '</div>' +
        '<div class="ddb-color-guide-name">' +
          '<span class="ddb-color-guide-swatch" style="background:' + HOT_PINK_HEX + ';" aria-hidden="true"></span>' +
          '<span class="ddb-color-guide-name-text">Hot Pink</span>' +
        '</div>';

      /* Insert after the Baby Pink tile if found, otherwise at the end. */
      var inserted = false;
      var allNames = grid.querySelectorAll('.ddb-color-guide-name-text');
      for (var k = 0; k < allNames.length; k++) {
        if (allNames[k].textContent.trim().toLowerCase() === 'baby pink') {
          var babyTile = allNames[k].closest('.ddb-color-guide-tile');
          if (babyTile && babyTile.parentNode === grid) {
            grid.insertBefore(tile, babyTile.nextSibling);
            inserted = true;
            break;
          }
        }
      }
      if (!inserted) grid.appendChild(tile);
    }
  }

  function runAll() {
    updateHotPinkSwatches();
    addGroovyGalleryTile();
  }

  function tryRun() {
    runAll();
    setTimeout(runAll, 300);
    setTimeout(runAll, 1000);
    setTimeout(runAll, 2500);
  }

  /* Observe the color step for late-rendered DOM (gallery toggle opens,
     step becomes active, etc.). */
  function startObserver() {
    var step = document.getElementById('ddb-step-color');
    if (!step) {
      setTimeout(startObserver, 500);
      return;
    }
    runAll();
    try {
      var obs = new MutationObserver(function () { runAll(); });
      obs.observe(step, { attributes: true, attributeFilter: ['class', 'hidden'], childList: true, subtree: true });
    } catch (e) {
      setInterval(runAll, 1500);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryRun();
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryRun(); startObserver(); });
    window.addEventListener('load', function () { tryRun(); startObserver(); });
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Gender Reveal Bento — custom accent step treatment.
   The accent1 step for this single product has only 2 options: "Like Image"
   and "All Vanilla White". We:
     1. Replace the swatch circle for "Like Image" with a 📸 camera emoji
        (since there's no color hex that meaningfully represents it)
     2. Preselect "Like Image" on page load (state + visual)
   Metafield setup expected on this product:
     - dbakers.has_colors = false
     - dbakers.accent1_label = "Cake color"
     - dbakers.accent1_count = 1
     - dbakers.accent1_subtitle = "Pick how the outside of the cake should look."
     - dbakers.accent1_options = "Like Image|#FAF7F1|true,All Vanilla White|#FAF7F1|true"
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var SPECIAL_HANDLES = ['gender-reveal-bento-cake'];

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  function isSpecialBento() {
    return SPECIAL_HANDLES.indexOf(getHandle()) !== -1;
  }

  function swapLikeImageSwatch() {
    if (!isSpecialBento()) return;
    /* Find the accent1 "Like Image" swatch in the accent1 step. */
    var step = document.getElementById('ddb-step-accent1');
    if (!step) return;
    var sw = step.querySelector('.ddb-accent-swatch[data-accent-value="Like Image"]');
    if (!sw) return;
    if (sw.dataset.likeImageCustomized === '1') return;
    var circle = sw.querySelector('.ddb-swatch-circle');
    if (!circle) return;
    /* Replace the colored circle with a camera emoji centered inside. */
    circle.style.background = '#fff';
    circle.style.border = '1.5px solid rgba(0,0,0,0.12)';
    circle.style.display = 'flex';
    circle.style.alignItems = 'center';
    circle.style.justifyContent = 'center';
    circle.style.fontSize = '28px';
    circle.innerHTML = '📸';
    sw.dataset.likeImageCustomized = '1';
  }

  function preselectLikeImage() {
    if (!isSpecialBento()) return;
    var step = document.getElementById('ddb-step-accent1');
    if (!step) return;
    var sw = step.querySelector('.ddb-accent-swatch[data-accent-value="Like Image"]');
    if (!sw) return;
    /* Skip if state already has a selection (don't override customer choice). */
    if (window.ddbState && window.ddbState.accent1 && window.ddbState.accent1[1]) return;
    /* Skip if already marked selected. */
    if (sw.classList.contains('is-selected')) return;
    /* Clear any other selected accent in the same group. */
    var sibs = step.querySelectorAll('.ddb-accent-swatch');
    for (var i = 0; i < sibs.length; i++) {
      sibs[i].classList.remove('is-selected');
      sibs[i].setAttribute('aria-checked', 'false');
    }
    sw.classList.add('is-selected');
    sw.setAttribute('aria-checked', 'true');
    /* Also update state if the builder's state object is reachable. The
       state in dbakers-designer-builder.js is closed over by the IIFE
       (not exposed on window), so we synthesize a click to drive it. */
    try { sw.click(); } catch (e) {}
  }

  function runAll() {
    swapLikeImageSwatch();
    preselectLikeImage();
  }

  function tryRun() {
    runAll();
    setTimeout(runAll, 300);
    setTimeout(runAll, 1000);
    setTimeout(runAll, 2500);
  }

  function startObserver() {
    var step = document.getElementById('ddb-step-accent1');
    if (!step) {
      setTimeout(startObserver, 500);
      return;
    }
    runAll();
    try {
      var obs = new MutationObserver(function () { swapLikeImageSwatch(); });
      obs.observe(step, { attributes: true, attributeFilter: ['class'], childList: true, subtree: false });
    } catch (e) {
      setInterval(swapLikeImageSwatch, 1500);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryRun();
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryRun(); startObserver(); });
    window.addEventListener('load', function () { tryRun(); startObserver(); });
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Per-handle bow-match override (JS-side hardcoded). Some cakes need the
   "letter color matches bow color" behavior even when the letter_color_matches_bow
   metafield isn't set. This block:
     1. Forces window.ddbProduct.letterColorMatchesBow = true for listed handles
     2. Sets a custom note text (window.ddbProduct.bowMatchLabel)
     3. Injects the visible note into the bow-color step
   Pattern matches the ombré / ball / macaron note injectors above.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var BOW_MATCH_CAKES = {
    'coquette-cake':               '🎀 Letter color will automatically match your bow color',
    'love-is-in-the-cake':         '🎀 Letter color and heart color will automatically match your bow color selection',
    'coquette-bento-cake':         '🎀 Letter color will automatically match your bow color',
    'love-is-in-the-bento-cake':   '🎀 Letter and heart color will automatically match your bow color selection'
  };

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  /* Override cfg so cart properties + state logic use the match-bow path. */
  (function applyCfgOverride() {
    var handle = getHandle();
    if (!handle) return;
    var label = BOW_MATCH_CAKES[handle];
    if (!label) return;
    if (!window.ddbProduct) window.ddbProduct = {};
    window.ddbProduct.letterColorMatchesBow = true;
    window.ddbProduct.bowMatchLabel = label;
  })();

  function injectBowMatchNote() {
    var handle = getHandle();
    var label = BOW_MATCH_CAKES[handle];
    if (!label) return;

    /* Inject into the bow-color step. */
    var bowStep = document.getElementById('ddb-step-bow-color');
    if (bowStep && !bowStep.querySelector('.ddb-bow-match-note-injected')) {
      var existing = bowStep.querySelectorAll('.ddb-color-disclaimer');
      var alreadyHasMatch = false;
      for (var i = 0; i < existing.length; i++) {
        if (existing[i].textContent.indexOf('match') !== -1 &&
            existing[i].textContent.indexOf('bow') !== -1) {
          alreadyHasMatch = true;
          break;
        }
      }
      if (!alreadyHasMatch) {
        var sub = bowStep.querySelector('.ddb-step-sub');
        if (sub) {
          var note = document.createElement('div');
          note.className = 'ddb-color-disclaimer ddb-bow-match-note-injected';
          note.setAttribute('role', 'note');
          note.style.cssText = 'background:#f0e8f8;color:#4a2a60;';
          note.textContent = label;
          sub.parentNode.insertBefore(note, sub.nextSibling);
        }
      }
    }

    /* Also inject into the lettering step (message step) so customer sees
       the note when they reach the letter color picker. */
    var msgStep = document.getElementById('ddb-step-message');
    if (msgStep && !msgStep.querySelector('.ddb-bow-match-msg-note-injected')) {
      var fields = document.getElementById('ddb-msg-style-fields');
      var anchor = fields || msgStep;
      var existingMsg = msgStep.querySelectorAll('.ddb-msg-note');
      var alreadyMsg = false;
      for (var j = 0; j < existingMsg.length; j++) {
        if (existingMsg[j].textContent.indexOf('match') !== -1 &&
            existingMsg[j].textContent.indexOf('bow') !== -1) {
          alreadyMsg = true;
          break;
        }
      }
      if (!alreadyMsg) {
        var p = document.createElement('p');
        p.className = 'ddb-msg-note ddb-bow-match-msg-note-injected';
        p.style.cssText = 'background:#f0e8f8;color:#4a2a60;padding:10px 12px;border-radius:8px;margin-bottom:14px;';
        p.textContent = label;
        if (anchor === fields && fields.firstChild) {
          fields.insertBefore(p, fields.firstChild);
        } else {
          anchor.appendChild(p);
        }
      }
    }
  }

  function tryRun() {
    injectBowMatchNote();
    setTimeout(injectBowMatchNote, 300);
    setTimeout(injectBowMatchNote, 1000);
    setTimeout(injectBowMatchNote, 2500);
  }

  function startObserver() {
    var bowStep = document.getElementById('ddb-step-bow-color');
    var msgStep = document.getElementById('ddb-step-message');
    var target = bowStep || msgStep;
    if (!target) {
      setTimeout(startObserver, 500);
      return;
    }
    injectBowMatchNote();
    try {
      var obs = new MutationObserver(function () { injectBowMatchNote(); });
      if (bowStep) obs.observe(bowStep, { attributes: true, attributeFilter: ['class'], childList: true, subtree: false });
      if (msgStep) obs.observe(msgStep, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    } catch (e) {
      setInterval(injectBowMatchNote, 1500);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryRun();
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryRun(); startObserver(); });
    window.addEventListener('load', function () { tryRun(); startObserver(); });
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Blank-card bonus note — injected into the Mini intro card on bentos.
   Liquid template adds this too, but injection ensures it lands even when
   Liquid changes aren't deploying. Idempotent.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  /* Handles that should NOT receive the blank-card bonus note. The Bento
     Flight is a flavor-focused 4-pack — there's no card included, so we
     skip the message there. Add other exclusions to this list as needed. */
  var BLANK_CARD_EXCLUDE = ['the-bento-flight'];

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  function injectBlankCardNote() {
    /* Bail entirely if this handle is on the exclusion list. */
    if (BLANK_CARD_EXCLUDE.indexOf(getHandle()) !== -1) return;
    var intro = document.getElementById('ddb-step-mini-intro');
    if (!intro) return;
    /* Already injected? Skip. */
    if (intro.querySelector('.ddb-blank-card-note-injected')) return;
    /* Already rendered by Liquid? Skip. */
    var existing = intro.querySelectorAll('.ddb-mini-intro-callout');
    for (var i = 0; i < existing.length; i++) {
      if (existing[i].textContent.indexOf('blank card') !== -1) return;
    }

    var note = document.createElement('div');
    note.className = 'ddb-mini-intro-callout ddb-blank-card-note-injected';
    note.style.cssText = 'background:#fff5e6;border-color:#f0c878;';
    note.innerHTML =
      '<div class="ddb-mini-intro-callout-label" style="color:#7a4d1a;">💌 BONUS</div>' +
      '<p class="ddb-mini-intro-callout-body" style="color:#7a4d1a;">' +
        'Every bento comes with a <strong>blank card</strong> you can handwrite a personal note on.' +
      '</p>';

    /* Insert after the existing "BEFORE YOU CONTINUE" callout. */
    var firstCallout = existing[0];
    if (firstCallout && firstCallout.parentNode) {
      firstCallout.parentNode.insertBefore(note, firstCallout.nextSibling);
    } else {
      var footnote = intro.querySelector('.ddb-mini-intro-footnote');
      if (footnote && footnote.parentNode) {
        footnote.parentNode.insertBefore(note, footnote);
      } else {
        intro.appendChild(note);
      }
    }
  }

  function tryRun() {
    injectBlankCardNote();
    setTimeout(injectBlankCardNote, 300);
    setTimeout(injectBlankCardNote, 1000);
    setTimeout(injectBlankCardNote, 2500);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryRun();
  } else {
    document.addEventListener('DOMContentLoaded', tryRun);
    window.addEventListener('load', tryRun);
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Per-handle flavor whitelist (JS-side hardcoded).
   Some cakes can only be made in certain flavors — e.g., gender reveal
   cakes need a vanilla-base cake to take dye for the colored interior.
   This injector hides any flavor card whose data-flavor isn't in the
   cake's allowed list. Idempotent and observer-driven.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  /* Map of handle → array of allowed flavor names (must match data-flavor
     exactly, including any emoji prefix). To add a new restricted cake,
     add an entry here. */
  var FLAVOR_WHITELIST = {
    /* Gender reveal cakes — interior gets dyed pink or blue, so the cake
       base must be vanilla-friendly to take the color. Allowed: vanilla
       variants plus the lightest specialty flavors that work with the
       dye process. */
    'what-will-i-be': [
      'Vanilla',
      'Vanilla Dulce de Leche',
      '▪️Tres Leches Passion Fruit',
      '✨ Lemon',
      '✨ Coconut'
    ],
    'gender-reveal-cake': [
      'Vanilla',
      'Vanilla Dulce de Leche',
      '▪️Tres Leches Passion Fruit',
      '✨ Lemon',
      '✨ Coconut'
    ],
    'gender-reveal-bento-cake': [
      'Vanilla',
      'Vanilla Dulce de Leche',
      '▪️Tres Leches Passion Fruit',
      '✨ Lemon',
      '✨ Coconut'
    ]
  };

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  function applyFlavorWhitelist() {
    var handle = getHandle();
    var allowed = FLAVOR_WHITELIST[handle];
    if (!allowed) return;

    var flavorStep = document.getElementById('ddb-step-flavor');
    if (!flavorStep) return;

    /* Only apply the restriction when the customer picked a dye-required
       gender option (Pink, Blue, or Letter). If they picked "No reveal"
       OR haven't picked yet, show the full flavor list. */
    var gender = (window.ddbState && window.ddbState.gender) ||
                 (typeof state !== 'undefined' && state && state.gender) || '';
    var restrictThisFlavor = gender === 'Pink' || gender === 'Blue' || gender === 'Letter';

    /* Build a normalized lookup so we don't get tripped up by whitespace
       differences. */
    var allowedSet = {};
    for (var i = 0; i < allowed.length; i++) {
      allowedSet[allowed[i].trim()] = true;
    }

    /* Find every flavor card / row. Show/hide based on whitelist when
       restriction is active; otherwise show all. */
    var cards = flavorStep.querySelectorAll('[data-flavor]');
    var visibleCount = 0;
    for (var j = 0; j < cards.length; j++) {
      var name = (cards[j].getAttribute('data-flavor') || '').trim();
      if (!restrictThisFlavor || allowedSet[name]) {
        cards[j].style.display = '';
        cards[j].removeAttribute('aria-hidden');
        cards[j].removeAttribute('tabindex');
        visibleCount++;
      } else {
        cards[j].style.display = 'none';
        cards[j].setAttribute('aria-hidden', 'true');
        cards[j].setAttribute('tabindex', '-1');
      }
    }

    /* Hide the search bar + filter pills + "Search or filter…" subtitle
       only when the restriction is active — with only 5 flavors, those
       affordances are noise. When the full flavor list is shown they
       come back. */
    var searchWrap = flavorStep.querySelector('.ddb-search-wrap');
    if (searchWrap) searchWrap.style.display = restrictThisFlavor ? 'none' : '';

    var filterPills = flavorStep.querySelector('.ddb-filter-pills');
    if (filterPills) filterPills.style.display = restrictThisFlavor ? 'none' : '';

    var subtitles = flavorStep.querySelectorAll('.ddb-step-sub');
    for (var s = 0; s < subtitles.length; s++) {
      if (subtitles[s].textContent.indexOf('Search or filter') !== -1) {
        subtitles[s].style.display = restrictThisFlavor ? 'none' : '';
      }
    }

    /* Inject / show the restriction notice only when restricted. */
    var existingNote = flavorStep.querySelector('.ddb-flavor-restrict-note');
    if (restrictThisFlavor) {
      if (!existingNote) {
        var sub = flavorStep.querySelector('.ddb-step-sub');
        if (sub) {
          var note = document.createElement('div');
          note.className = 'ddb-color-disclaimer ddb-flavor-restrict-note';
          note.setAttribute('role', 'note');
          note.style.cssText = 'background:#f0e8f8;color:#4a2a60;margin-top:8px;';
          note.innerHTML = '🎨 <strong>This cake gets a dyed interior, so we only offer vanilla-base flavors that take the color cleanly.</strong>';
          sub.parentNode.insertBefore(note, sub.nextSibling);
        }
      } else {
        existingNote.style.display = '';
      }
    } else if (existingNote) {
      existingNote.style.display = 'none';
    }
  }

  function tryRun() {
    applyFlavorWhitelist();
    setTimeout(applyFlavorWhitelist, 200);
    setTimeout(applyFlavorWhitelist, 800);
    setTimeout(applyFlavorWhitelist, 2000);
    setTimeout(applyFlavorWhitelist, 4000);
  }

  function startObserver() {
    var step = document.getElementById('ddb-step-flavor');
    if (!step) {
      setTimeout(startObserver, 500);
      return;
    }
    applyFlavorWhitelist();
    try {
      var obs = new MutationObserver(function () { applyFlavorWhitelist(); });
      obs.observe(step, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    } catch (e) {
      setInterval(applyFlavorWhitelist, 1500);
    }
    /* Re-apply whitelist whenever the customer changes their gender pick
       (Pink/Blue/Letter restricts flavor list; "No reveal" un-restricts). */
    document.addEventListener('ddb:gender-changed', function () { applyFlavorWhitelist(); });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryRun();
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryRun(); startObserver(); });
    window.addEventListener('load', function () { tryRun(); startObserver(); });
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Gender Reveal cake activation (JS-side hardcoded handle list).
   The Liquid template renders the gender step DOM but hides it with the
   `hidden` attribute by default. This block:
     1. Lists the 3 cakes that should show the gender step
     2. Sets window.ddbProduct.showsGenderStep = true on those handles
        BEFORE the builder's init() runs (so buildSteps picks it up)
     3. Removes the `hidden` attribute from the gender step element
   Runs as early as possible — must happen before init() to be picked up
   by buildSteps. We run it in a synchronous IIFE at script load time.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var GENDER_REVEAL_CAKES = [
    'what-will-i-be',          /* Designer cake — What Will I Be?       */
    'gender-reveal-cake',      /* Designer cake — Gender Reveal Pull-Up */
    'gender-reveal-bento-cake' /* Bento — Gender Reveal Bento Cake      */
  ];

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  /* Step 1 — set the flag on window.ddbProduct so buildSteps picks it up. */
  (function applyFlag() {
    var handle = getHandle();
    if (GENDER_REVEAL_CAKES.indexOf(handle) === -1) return;
    if (!window.ddbProduct) window.ddbProduct = {};
    window.ddbProduct.showsGenderStep = true;
  })();

  /* Step 2 — un-hide the step element. The Liquid renders it with the
     `hidden` HTML attribute, which we strip here so the step becomes
     navigable when buildSteps adds it to state.steps. */
  function unhideStep() {
    var handle = getHandle();
    if (GENDER_REVEAL_CAKES.indexOf(handle) === -1) return;
    var step = document.getElementById('ddb-step-gender');
    if (!step) return;
    if (step.hasAttribute('hidden')) step.removeAttribute('hidden');
  }

  function tryUnhide() {
    unhideStep();
    setTimeout(unhideStep, 200);
    setTimeout(unhideStep, 800);
    setTimeout(unhideStep, 2000);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryUnhide();
  } else {
    document.addEventListener('DOMContentLoaded', tryUnhide);
    window.addEventListener('load', tryUnhide);
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Hide the "groovy" letter style on all bento cakes. Groovy is a designer-
   cake-only style — it's too bold for a 4" mini. Detection: bentos use
   the Mini intro step, which is only rendered when window.ddbProduct.isMini
   is true (set by the Liquid based on product.variants.size == 1). Same
   guard as the price-bar label fix. Idempotent + observer-driven.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  function isBento() {
    /* Several signals — any one means this is a bento */
    if (window.ddbProduct && window.ddbProduct.isMini) return true;
    if (document.getElementById('ddb-step-mini-intro')) return true;
    return false;
  }

  function hideGroovyOnBentos() {
    if (!isBento()) return;
    var msgStep = document.getElementById('ddb-step-message');
    if (!msgStep) return;
    /* Letter style cards live inside the message step. Each card has
       data-style="<style-id>" matching the style identifier in the
       Liquid template (groovy, fondant, cursive, block, none). */
    var groovyCards = msgStep.querySelectorAll('[data-style="groovy"]');
    for (var i = 0; i < groovyCards.length; i++) {
      groovyCards[i].style.display = 'none';
      groovyCards[i].setAttribute('aria-hidden', 'true');
      groovyCards[i].setAttribute('tabindex', '-1');
    }
  }

  function tryRun() {
    hideGroovyOnBentos();
    setTimeout(hideGroovyOnBentos, 200);
    setTimeout(hideGroovyOnBentos, 800);
    setTimeout(hideGroovyOnBentos, 2000);
  }

  function startObserver() {
    var step = document.getElementById('ddb-step-message');
    if (!step) {
      setTimeout(startObserver, 500);
      return;
    }
    hideGroovyOnBentos();
    try {
      var obs = new MutationObserver(function () { hideGroovyOnBentos(); });
      obs.observe(step, { childList: true, subtree: true });
    } catch (e) {
      setInterval(hideGroovyOnBentos, 1500);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryRun();
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryRun(); startObserver(); });
    window.addEventListener('load', function () { tryRun(); startObserver(); });
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   2-Tier thumbnail image updater. Liquid renders the size-step thumbnails
   inline, but in case the Liquid is stale on a deployed theme, this
   injector forces the latest image URLs onto the 2-Tier Small and 2-Tier
   Large cards by data-variant-title. Idempotent and observer-driven.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var TIER_THUMBS = {
    '2-Tier Small': 'https://cdn.shopify.com/s/files/1/0248/2772/3823/files/2_Tier_Small_Thumbnail.png?v=1778199516',
    '2-Tier Large': 'https://cdn.shopify.com/s/files/1/0248/2772/3823/files/2_Tier_Large_Thumbnail.png?v=1778199514'
  };

  function updateTierThumbs() {
    var sizeStep = document.getElementById('ddb-step-size');
    if (!sizeStep) return;
    for (var title in TIER_THUMBS) {
      if (!TIER_THUMBS.hasOwnProperty(title)) continue;
      var card = sizeStep.querySelector('.ddb-size-card[data-variant-title="' + title + '"]');
      if (!card) continue;
      var img = card.querySelector('.ddb-size-thumb img');
      if (img) {
        if (img.src !== TIER_THUMBS[title]) {
          img.src = TIER_THUMBS[title];
        }
      } else {
        /* No img element yet — inject one. */
        var thumb = card.querySelector('.ddb-size-thumb');
        if (thumb) {
          var newImg = document.createElement('img');
          newImg.src = TIER_THUMBS[title];
          newImg.alt = title + ' cake size illustration';
          newImg.width = 120; newImg.height = 120;
          newImg.loading = 'lazy';
          newImg.decoding = 'async';
          newImg.onerror = function () { this.style.display = 'none'; };
          thumb.appendChild(newImg);
        }
      }
    }
  }

  function tryRun() {
    updateTierThumbs();
    setTimeout(updateTierThumbs, 300);
    setTimeout(updateTierThumbs, 1000);
    setTimeout(updateTierThumbs, 2500);
  }

  function startObserver() {
    var step = document.getElementById('ddb-step-size');
    if (!step) {
      setTimeout(startObserver, 500);
      return;
    }
    updateTierThumbs();
    try {
      var obs = new MutationObserver(function () { updateTierThumbs(); });
      obs.observe(step, { childList: true, subtree: true });
    } catch (e) {
      setInterval(updateTierThumbs, 1500);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryRun();
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryRun(); startObserver(); });
    window.addEventListener('load', function () { tryRun(); startObserver(); });
  }
})();

/* ────────────────────────────────────────────────────────────────────────────
   Bento Flight intro text override.
   The Bento Flight is a 4-bento tasting pack, not a single-bento product, so
   the standard "serves 1 person" / "fits in your palm" copy is wrong. This
   injector swaps in Flight-specific copy on the Mini intro card.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var FLIGHT_HANDLE = 'the-bento-flight';

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  function applyFlightIntroCopy() {
    if (getHandle() !== FLIGHT_HANDLE) return;
    var intro = document.getElementById('ddb-step-mini-intro');
    if (!intro) return;

    /* Swap the lede line (top description). */
    var lede = intro.querySelector('.ddb-mini-intro-lede');
    if (lede && lede.textContent.indexOf('one person') !== -1) {
      lede.innerHTML = "Four 4&quot; bento cakes, four different flavors &mdash; a tasting flight built for sharing. \u2728";
    }

    /* Swap the "BEFORE YOU CONTINUE" callout body. */
    var callouts = intro.querySelectorAll('.ddb-mini-intro-callout-body');
    for (var i = 0; i < callouts.length; i++) {
      var body = callouts[i];
      if (body.textContent.indexOf('serves') !== -1 && body.textContent.indexOf('1 person') !== -1) {
        body.innerHTML = "This is a <strong>4-pack tasting flight</strong> &mdash; pick up to 4 flavors and we'll bake one bento of each. Great for sharing with friends, family, or treating yourself across the week.";
        break;
      }
    }
  }

  function tryRun() {
    applyFlightIntroCopy();
    setTimeout(applyFlightIntroCopy, 300);
    setTimeout(applyFlightIntroCopy, 1000);
    setTimeout(applyFlightIntroCopy, 2500);
  }

  function startObserver() {
    var intro = document.getElementById('ddb-step-mini-intro');
    if (!intro) {
      setTimeout(startObserver, 500);
      return;
    }
    applyFlightIntroCopy();
    try {
      var obs = new MutationObserver(function () { applyFlightIntroCopy(); });
      obs.observe(intro, { childList: true, subtree: true, characterData: true });
    } catch (e) {
      setInterval(applyFlightIntroCopy, 1500);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryRun();
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryRun(); startObserver(); });
    window.addEventListener('load', function () { tryRun(); startObserver(); });
  }
})();
/* ────────────────────────────────────────────────────────────────────────────
   Per-handle "Like Image" removal on the color step. Listed single-color
   cakes hide the "Like Image" swatch so the customer must pick a real
   color. Idempotent — once hidden, it stops mutating so the observer
   doesn't re-fire in a loop.
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  var HIDE_LIKE_IMAGE_HANDLES = [
    'custom-character-cake',
    'character-bento-cake'
  ];

  function getHandle() {
    if (window.ddbProduct && window.ddbProduct.handle) return window.ddbProduct.handle;
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : '';
  }

  function hideLikeImage() {
    if (HIDE_LIKE_IMAGE_HANDLES.indexOf(getHandle()) === -1) return;
    var colorStep = document.getElementById('ddb-step-color');
    if (!colorStep) return;
    var swatches = colorStep.querySelectorAll('.ddb-swatch[data-color="Like Image"]');
    for (var i = 0; i < swatches.length; i++) {
      var sw = swatches[i];
      /* Already hidden? Skip — do NOT touch attributes again, or the
         observer below will fire on our own mutation and loop forever. */
      if (sw.classList.contains('ddb-swatch--hidden')) continue;
      sw.classList.add('ddb-swatch--hidden');
      sw.setAttribute('aria-hidden', 'true');
      sw.setAttribute('tabindex', '-1');
    }
  }

  function tryRun() {
    hideLikeImage();
    setTimeout(hideLikeImage, 300);
    setTimeout(hideLikeImage, 1000);
    setTimeout(hideLikeImage, 2500);
  }

  function startObserver() {
    var step = document.getElementById('ddb-step-color');
    if (!step) { setTimeout(startObserver, 500); return; }
    hideLikeImage();
    try {
      /* Watch only class changes on the step element itself (is-active
         toggle), NOT subtree attributes — so our own setAttribute calls
         on the swatches can't feed back into the observer. */
      var obs = new MutationObserver(function () { hideLikeImage(); });
      obs.observe(step, { attributes: true, attributeFilter: ['class'], childList: true, subtree: false });
    } catch (e) {
      setInterval(hideLikeImage, 1500);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    tryRun();
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', function () { tryRun(); startObserver(); });
    window.addEventListener('load', function () { tryRun(); startObserver(); });
  }
})();